<template>
  <div id="app">
    <stripe-checkout
      ref="checkoutRef"
      mode="payment"
      :pk="publishableKey"
      :line-items="lineItems"
      :success-url="successURL"
      :cancel-url="cancelURL"
      @loading="v => loading = v"
    />

    <v-dialog v-model="tursabUyariDialog" width="400">
      <v-card>
        <v-card-title>
          <v-toolbar flat color="info" dark><v-toolbar-title>{{ $t('TURSAB-Baslangic-Paketi-Uyari') }}</v-toolbar-title></v-toolbar>
        </v-card-title>
        <v-card-text>
          {{ $t('TURSAB-Onceden-Alinmis-Paket-Uyarisi') }}
        </v-card-text>
        <v-card-actions>
          <v-layout justify-end>
            <v-btn color="primary" @click="tursabUyariDialog=false">{{ $t('Close') }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="tursabCardDialog" persistent width="400">
      <v-card>
        <v-card-title>{{ $t('TURSAB-Kart-Bilgileriniz') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-form ref="formtursabcard" v-model="validOdeme" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field hide-details :rules="[v => !!v || $t('Please-enter-your-invoice-number')]"
                    v-model="tursabcard.CardNumber" :label="$t('Card-No')" mask="####-####-####-####"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field hide-details v-model="tursabcard.CardHolder"
                    :rules="[v => !!v || $t('Mandatory-Areas')]" :label="$t('Name-on-Card')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-select :items="sonkullanimAy" :label="$t('Expiry-Month')" v-model="tursabcard.ExpirationMonth"
                    :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details item-text="text" item-value="id"></v-select>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-select :items="sonkullanimYil" v-model="tursabcard.ExpirationYear"
                    :label="$t('Expiry-Year')" hide-details :rules="[v => !!v || $t('Mandatory-Areas')]" item-text="text" item-value="id"></v-select>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-text-field :label="$t('CVV')" v-model="tursabcard.Cvv" hide-details mask="###"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-text-field :label="$t('Tursab-Belge-No')" v-model="tursabcard.tursabbelgeno"
                    :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="tursabcardialogkapat()">{{ $t("cancel_button") }}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="tursabcarddogrula()">{{ $t("Apply") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="tursabSartlarDialog" persistent>
      <v-card>
        <v-card-title>
          <v-toolbar flat color="info" dark><v-toolbar-title>{{ $t('TURSAB-Kullanim-Sartlari-Baslik') }}</v-toolbar-title></v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step :complete="e1 > 1" step="1">{{ $t('Faturalar-Raporlar-ve-Icerikler') }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="e1 > 2" step="2">{{ $t('Egitim-ve-Destek-Hizmetleri') }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3">{{ $t('Uyelik-ve-Yenileme-Bilgileri') }}</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card class="mb-5">
                  <v-card-text class="pa-4">
                    <ul>
                      <li>{{ $t('Tursab-Sart-Efatura') }}</li>
                      <li>{{ $t('Tursab-Sart-Fatura-Dizayn') }}</li>
                      <li>{{ $t('Tursab-Sart-Voucher-Dizayn') }}</li>
                    </ul>
                  </v-card-text>
                </v-card>
                <v-layout justify-start><v-btn color="primary" @click="tursabSartlarDialog = false">{{ $t('Cancel') }}</v-btn></v-layout>
                <v-layout justify-end><v-btn color="success" @click="e1 = 2">{{ $t('Sartlari-Kabul-Ediyorum') }}</v-btn></v-layout>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card class="mb-5">
                  <v-card-text class="pa-4">
                    <ul>
                      <li>{{ $t('Tursab-Sart-Egitim-Koordineli') }}</li>
                      <li>{{ $t('Tursab-Sart-Destek-Yazili') }}</li>
                    </ul>
                  </v-card-text>
                </v-card>
                <v-layout justify-start>
                  <v-btn color="primary" @click="e1 = 1">{{ $t('GoBack') }}</v-btn>
                  <v-btn color="primary" @click="tursabSartlarDialog = false">{{ $t('Cancel') }}</v-btn>
                </v-layout>
                <v-layout justify-end><v-btn color="success" @click="e1 = 3">{{ $t('Sartlari-Kabul-Ediyorum') }}</v-btn></v-layout>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-card class="mb-5">
                  <v-card-text class="pa-4">
                    <ul>
                      <li>{{ $t('Tursab-Sart-Tursab-Kart-Indirim') }}</li>
                      <li>{{ $t('Tursab-Sart-Tek-Acente') }}</li>
                    </ul>
                  </v-card-text>
                </v-card>
                <v-layout justify-start>
                  <v-btn color="primary" @click="e1 = 2">{{ $t('GoBack') }}</v-btn>
                  <v-btn color="primary" @click="tursabSartlarDialog = false">{{ $t('Cancel') }}</v-btn>
                </v-layout>
                <v-layout justify-end><v-btn color="success" @click="SartlarKabul()">{{ $t('Sartlari-Kabul-Ediyorum') }}</v-btn></v-layout>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingdialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('Your-process-progress') }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <genelsatissozlesme ref="genelsatissozlesme"></genelsatissozlesme>

    <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">{{ $t('Products') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-dialog v-if="octetKrediKartiDialog" v-model="octetKrediKartiDialog" max-width="800px">
      <v-card>
        <v-card-text>
          <iframe width="100%" height="500" :src="octetReturnUrl" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="fatDialog" persistent width="1024">
      <v-form v-model="isFatValid">
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12><h4>{{ $t('Fatura-Bilgileri') }}</h4><hr /></v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="fatUnvan" :label="$t('Title_label') + '*'" required :rules="[v => !!v || $t('Mandatory-Areas')]"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="fatVergiDairesi" :label="$t('Taxcenter_label') + '*'" :rules="[v => !!v || $t('Mandatory-Areas')]" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="fatVergiNo" :label="$t('Tax-No') + '*'" :rules="[v => !!v || $t('Mandatory-Areas')]" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea v-model="fatAcikAdres" :rules="[v => !!v || $t('Mandatory-Areas')]" :label="$t('Open-Address')" required></v-textarea>
                </v-flex>
                <v-flex xs12 sm6 md4><v-text-field :label="$t('Postcode_label')" v-model="fatPostaKod"></v-text-field></v-flex>
                <v-flex xs12 sm6 md4><v-text-field v-model="fatSehir" :label="$t('City') + '*'" :rules="[v => !!v || $t('Mandatory-Areas')]"></v-text-field></v-flex>
                <v-flex xs12 sm6 md4><v-text-field v-model="fatIlce" :label="$t('District')"></v-text-field></v-flex>
                <v-flex xs12 sm12 md12>
                  <v-autocomplete v-model="fatUlke" :items="['Türkiye', 'KKTC']" :label="$t('Country_label')" required :rules="[v => !!v || $t('Mandatory-Areas')]"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
            <small>{{ $t('Isaretli-Alanlar-Zorunludur') }}</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="fatDialog = false">{{ $t("cancel_button") }}</v-btn>
            <v-btn color="blue darken-1" flat @click="FaturaBilgileriGuncellev2()" :disabled="!isFatValid">{{ $t('save_button') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <navi v-model="drawer"></navi>
    <altaciklama></altaciklama>

    <div id="maindiv" class="maindiv-wrap">
      <v-container fluid>

          <!-- Yeni tasarım ana bölüm -->
          <div v-if="urunekrani" class="page">
            <div class="hdr">
              <h1>{{ $t('Uyelik-Plani-Secin') }}</h1>
              <p>{{ $t('Uyelik-Plani-Aciklama') }}</p>
            </div>

            <!-- Şirket seçimi -->
            <div class="co-box">
              <div class="co-head">
                <div class="co-head-icon">&#127970;</div>
                <div class="co-head-txt">
                  <strong>{{ $t('Firma-Bilgisi') }}</strong>
                  <span>{{ $t('Mevcut-Firma-Sec-Aciklama') }}</span>
                </div>
              </div>
              <div class="co-body">
                <div class="co-radios">
                  <label class="co-radio">
                    <input type="radio" value="0" v-model="sirkettipi">
                    <div class="co-radio-label">
                      <span class="co-radio-ico">&#127970;</span>
                      <span class="co-radio-dot"></span>
                      <div class="co-radio-txt">
                        <strong>{{ $t('Existing-Company') }}</strong>
                        <span>{{ $t('Kayitli-Firmamdan-Devam-Et') }}</span>
                      </div>
                    </div>
                  </label>
                  <label class="co-radio">
                    <input type="radio" value="1" v-model="sirkettipi">
                    <div class="co-radio-label">
                      <span class="co-radio-ico">&#10024;</span>
                      <span class="co-radio-dot"></span>
                      <div class="co-radio-txt">
                        <strong>{{ $t('New-Company') }}</strong>
                        <span>{{ $t('Yeni-Firma-Kaydi-Olustur') }}</span>
                      </div>
                    </div>
                  </label>
                </div>

                <div v-if="sirkettipi=='0'">
                  <span class="co-select-lbl">{{ $t('Select-Your-Main-Company') }}</span>
                  <div class="co-select-wrap">
                    <select class="co-select" v-model="AnaSirket">
                      <option :value="null">{{ '-- ' + $t('Firma-Seciniz-Placeholder') + ' --' }}</option>
                      <option v-for="s in AnaSirketler" :key="s.id" :value="s.id">{{ s.text }}</option>
                    </select>
                    <span class="co-select-arrow">&#9660;</span>
                  </div>
                </div>

                <div v-if="sirkettipi=='1'" class="co-new-wrap show">
                  <div class="co-new-btn-wrap">
                    <button class="co-new-open-btn" type="button" @click="openNewCoModal()">
                      <span class="co-new-btn-icon">&#10010;</span>
                      <div class="co-new-btn-txt">
                        <strong>{{ $t('Add-New-Company') }}</strong>
                        <span>{{ $t('Firma-Bilgilerini-Girerek-Kayit-Olustur') }}</span>
                      </div>
                      <span class="co-new-btn-arrow">&#8594;</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="tabs">
              <button class="tab" :class="{active: activeSection==='paketler'}" @click="switchSection('paketler')">
                &#128230; {{ $t('Packages') }}
              </button>
              <button class="tab" :class="{active: activeSection==='kontor'}" @click="switchSection('kontor')">
                &#127809; {{ $t('Ek-Kontor') }}
              </button>
            </div>

            <!-- PAKETLER BÖLÜMÜ -->
            <div v-if="activeSection==='paketler'">
              <div class="bill-wrap">
                <div class="bill-seg">
                  <button class="bill-btn" :class="{active: aylikyillikpaketler==='0'}" @click="aylikyillikpaketler='0'">
                    <span>{{ $t('Monthly') }}</span>
                    <span class="bill-sub">{{ $t('Esnek-Odeme') }}</span>
                  </button>
                  <button class="bill-btn yearly" :class="{active: aylikyillikpaketler==='1'}" @click="aylikyillikpaketler='1'">
                    <span>{{ $t('Annual') }}</span>
                    <span class="bill-sub">{{ $t('En-Avantajli') }}</span>
                    <span class="bill-gift">&#127873; {{ $t('Bir-Ay-Bedava') }}</span>
                  </button>
                </div>
              </div>

              <div v-if="aylikyillikpaketler==='1' && productshow.length > 0" class="yr-banner show">
                <div class="ban-stripe"></div>
                <div class="ban-body">
                  <div class="ban-icon">&#127873;</div>
                  <div class="ban-txt">
                    <strong>{{ $t('Yillik-Planda-Bir-Ay-Bedava') }}</strong>
                    <span>{{ $t('Yillik-Plan-Aciklama') }}</span>
                  </div>
                  <div class="ban-pill">{{ maxYearlyTasarruf | moneyformat }}{{ parabirimi | parabirimi }}{{ $t('Ya-Kadar-Avantaj-Imkani') }}</div>
                </div>
              </div>

              <div class="grid">
                <div
                  v-for="(item, idx) in productshow"
                  :key="item.PaketID"
                  class="card"
                  :class="{featured: idx === featuredIndex}"
                >
                  <div class="badge-row">
                    <div v-if="idx === featuredIndex" class="pop-lbl">
                      <span class="pop-star">&#9733;</span> {{ $t('En-Populer') }}
                    </div>
                  </div>
                  <div class="card-top">
                    <div class="card-name">{{ item.PaketAdi }}</div>
                  </div>
                  <div class="divider"></div>
                  <div class="feats">
                    <div class="feat"><span class="fi">&#9992;</span>{{ item.BiletAdet | fmtInt }} {{ $t('Ticket') }}</div>
                    <div class="feat"><span class="fi">&#127968;</span>{{ item.CoperAdet | fmtInt }} Coper</div>
                    <div class="feat"><span class="fi">&#128176;</span>{{ item.CariAdet | fmtInt }} {{ $t('Serbest-Cari-Hareket') }}</div>
                  </div>
                  <div class="price-box">
                    <template v-if="aylikyillikpaketler === '1'">
                      <div class="price-was">{{ monthlyFiyat(item) * 12 | moneyformat }} &#8378;</div>
                      <div class="price-amt">{{ item.Fiyat | moneyformat }} &#8378;</div>
                      <div class="price-per">{{ $t('Annual') }}</div>
                      <div class="price-save">&#128176; {{ (monthlyFiyat(item) * 12 - item.Fiyat) | moneyformat }} &#8378; {{ $t('Tasarruf') }}</div>
                    </template>
                    <template v-else>
                      <div class="price-amt">{{ item.Fiyat | moneyformat }} &#8378;</div>
                      <div class="price-per">{{ $t('Monthly') }}</div>
                    </template>
                  </div>
                  <div class="actions">
                    <button class="btn-det" @click="urundetayGetir(item)">&#128196; {{ $t('Paket-Detaylari') }}</button>
                    <button class="btn-buy" @click="buyPaketCheck(item)">&#128722; {{ $t('Buy') }}</button>
                  </div>
                </div>

                <!-- Lisans kartı -->
                <div class="card lisans">
                  <div class="badge-row">
                    <div class="pop-lbl">
                      <span class="pop-star" style="background:#f59e0b">&#9670;</span> {{ $t('Lisans') }}
                    </div>
                  </div>
                  <div class="card-top">
                    <span class="lisans-icon">&#127959;</span>
                    <div class="lisans-title">{{ $t('Lisans-Alimi') }}</div>
                    <div class="lisans-sub">{{ $t('Kurumsal-Ozel-Cozum') }}</div>
                  </div>
                  <div class="lisans-divider"></div>
                  <div class="lisans-feats">
                    <div class="lisans-feat"><span class="lisans-check">&#10003;</span>{{ $t('Sinirsiz-Veri-Girisi') }}</div>
                    <div class="lisans-feat"><span class="lisans-check">&#10003;</span>{{ $t('Kendi-Sunucunuzda-Barindirma') }}</div>
                    <div class="lisans-feat"><span class="lisans-check">&#10003;</span>{{ $t('Ozel-Web-Service-Katmani') }}</div>
                    <div class="lisans-feat"><span class="lisans-check">&#10003;</span>{{ $t('Kendi-Yazilimlarinizla-Next-Arkman-Entegrasyonu') }}</div>
                  </div>
                  <div class="lisans-cta">
                    <button class="btn-lisans" @click="callLisans()">&#128222; {{ $t('Hemen-Iletisim-Kurun') }}</button>
                    <div class="lisans-phone">+90 850 811 12 84</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- EK KONTÖR BÖLÜMÜ -->
            <div v-if="activeSection==='kontor'" class="k-layout">
              <div>
                <div class="k-grid">
                  <div
                    v-for="(k, idx) in kpkgList"
                    :key="idx"
                    class="k-card"
                    :class="{'k-feat': k.feat}"
                  >
                    <div class="k-badge-row">
                      <div v-if="k.feat" class="k-pop">
                        <span class="k-star">&#9733;</span> {{ $t('En-Populer') }}
                      </div>
                    </div>
                    <div class="k-card-body">
                      <div class="k-qty">{{ k.qty | fmtInt }}<span> {{ $t('Kontor') }}</span></div>
                      <template v-if="k.gift > 0">
                        <div class="k-gift">&#127873; +{{ k.gift | fmtInt }} {{ $t('Hediye') }}</div>
                        <div style="font-size:11px;color:#718096;margin-top:3px">
                          {{ $t('Total') }}: <strong style="color:#1a3a6b">{{ k.total | fmtInt }} {{ $t('Kontor') }}</strong>
                        </div>
                      </template>
                      <div v-else class="k-gift-empty"></div>
                      <div class="k-price">{{ k.price | moneyformat }} &#8378;</div>
                      <div class="k-unit-wrap">
                        <div class="k-unit-label">{{ $t('Kontor-Basi-Fiyat') }}</div>
                        <template v-if="k.gift > 0">
                          <div class="k-unit-price">{{ k.unitReal.toFixed(2) }}&#8378;</div>
                          <div class="k-unit-old">{{ k.unitStd.toFixed(2) }}&#8378; {{ $t('Yerine') }}</div>
                          <div class="k-unit-saving">&#127881; %{{ k.pctSaved }} {{ $t('Daha-Ucuz') }}</div>
                        </template>
                        <template v-else>
                          <div class="k-unit-price" style="color:#4a5568;font-size:16px">{{ k.unitStd.toFixed(2) }}&#8378;</div>
                        </template>
                      </div>
                    </div>
                    <div class="k-card-actions">
                      <button class="k-btn" @click="buyKPkg(k)">&#128722; {{ $t('Buy') }}</button>
                    </div>
                  </div>
                </div>

                <div class="k-custom">
                  <div class="k-custom-head">
                    <div class="k-custom-head-icon">&#9999;</div>
                    <div class="k-custom-head-txt">
                      <strong>{{ $t('Istediginiz-Kadar-Kontor') }}</strong>
                      <span>{{ $t('Tam-Ihtiyaciniz-Kadar-Aciklama') }}</span>
                    </div>
                  </div>
                  <div class="k-custom-body">
                    <p>{{ $t('Yukaridaki-Paketler-Disinda-Aciklama') }}</p>
                    <div class="k-custom-row">
                      <input type="number" v-model.number="kontorAdet" min="1" />
                      <span>{{ $t('Kontor') }} &nbsp;&times;&nbsp; {{ kontorBirimFiyat.toFixed(2) }} &#8378;</span>
                    </div>
                    <div class="k-custom-res">
                      {{ kontorAdet | fmtInt }} &times; {{ kontorBirimFiyat.toFixed(2) }} &#8378; =
                      <strong>{{ (kontorAdet * kontorBirimFiyat) | moneyformat }} &#8378;</strong>
                    </div>
                    <button class="k-custom-btn" @click="buyCustomKontor()">&#128722; {{ $t('Buy') }}</button>
                  </div>
                </div>
              </div>

              <div class="burn-panel">
                <div class="burn-head">
                  <span>&#128293;</span>
                  <div>
                    <h3>{{ $t('Kontor-Yakma-Tablosu') }}</h3>
                    <div class="burn-desc">{{ $t('Her-Islem-Ne-Kadar-Kontor-Tuketir') }}</div>
                  </div>
                </div>
                <table class="burn-tbl">
                  <tbody>
                    <tr><td><span class="burn-fi">&#9992;</span>{{ $t('Ticket') }}</td><td>{{ $t('Burn-Islem-1-1') }}</td></tr>
                    <tr><td><span class="burn-fi">&#128683;</span>Void</td><td>{{ $t('Burn-Islem-5-1') }}</td></tr>
                    <tr><td><span class="burn-fi">&#8617;</span>{{ $t('Refund') }}</td><td>{{ $t('Burn-Islem-1-1') }}</td></tr>
                    <tr><td><span class="burn-fi">&#127968;</span>Coper ({{ $t('Record') }})</td><td>{{ $t('Burn-Kayit-1-2') }}</td></tr>
                    <tr><td><span class="burn-fi">&#10005;</span>Coper {{ $t('Cancel') }}</td><td>{{ $t('Burn-Islem-5-1') }}</td></tr>
                    <tr><td><span class="burn-fi">&#128203;</span>{{ $t('Visa') }}</td><td>{{ $t('Burn-Kayit-1-3') }}</td></tr>
                    <tr><td><span class="burn-fi">&#128176;</span>{{ $t('Serbest-Cari-Hareket') }}</td><td>{{ $t('Burn-Islem-5-1') }}</td></tr>
                    <tr><td><span class="burn-fi">&#129534;</span>{{ $t('Bill') }}</td><td>{{ $t('Burn-Islem-1-1') }}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Ödeme ekranı -->
          <div v-if="odemeekrani" class="odeme-page">

            <!-- Üst toolbar -->
            <div class="odeme-toolbar">
              <div class="odeme-toolbar-title">
                {{ $t('Payment') }}
                <span v-if="alinanUrun && pakettipi !== '2'" class="odeme-toolbar-sub">
                  — {{ alinanUrun }}
                  <span v-if="pakettipi === '1'">({{ aylikyillikpaketler === '1' ? $t('Annual') : $t('Monthly') }})</span>
                </span>
                <span v-if="pakettipi === '2'" class="odeme-toolbar-sub">— {{ kontorAdet | fmtInt }} {{ $t('Kontor') }}<template v-if="kontorHediyeAdet > 0"> + {{ kontorHediyeAdet | fmtInt }} {{ $t('Hediye') }} = {{ (kontorAdet + kontorHediyeAdet) | fmtInt }} {{ $t('Kontor') }}</template></span>
              </div>
              <button class="odeme-back-btn" @click="urunleredon()">&#8592; {{ $t('Select-Product') }}</button>
            </div>

            <!-- Yıllık fırsat banneri (sadece aylık paket seçiliyse) -->
            <div v-if="aylikyillikpaketler === '0' && pakettipi === '1' && !bannerGizli" class="sm-banner">
              <div class="sm-stripe"></div>
              <div class="sm-inner">
                <div class="sm-left">
                  <div class="sm-icon">&#9888;</div>
                  <div class="sm-body">
                    <strong>{{ $t('Aylik-Yerine-Yillik-Baslik') }}</strong>
                    <span>{{ $t('Aylik-Toplam-Odersiniz-Pre') }} <strong>{{ toplamtutar * 12 | moneyformat }}{{ parabirimi | parabirimi }}</strong> {{ $t('Aylik-Toplam-Odersiniz-Post') }}</span>
                    <div class="sm-pills">
                      <span class="sm-pill">&#127873; {{ $t('Bir-Ay-Bedava-Kucuk') }}</span>
                      <span class="sm-pill">&#9989; {{ $t('Kesinti-Riski-Yok') }}</span>
                      <span class="sm-pill">&#128197; {{ $t('Tek-Odeme-Rahatligi') }}</span>
                    </div>
                  </div>
                </div>
                <div class="sm-numbers">
                  <div class="sm-num-card sm-monthly">
                    <div class="sm-num-lbl">{{ $t('Aylik-Planla-12-Ayda-En-Az') }}</div>
                    <div class="sm-num-val">{{ toplamtutar * 12 | moneyformat }}{{ parabirimi | parabirimi }}</div>
                    <div class="sm-num-sub">{{ $t('Oderdiniz') }}</div>
                    <div class="sm-infl">{{ $t('Enflasyon-Zamlarla') }}<br><span class="sm-infl-badge">&#9650; {{ $t('Daha-Da-Fazlasini-Odersiniz') }}</span></div>
                  </div>
                  <div class="sm-arrow">&#8594;</div>
                  <div class="sm-num-card sm-save">
                    <div class="sm-save-stripe"></div>
                    <div class="sm-save-inner">
                      <div class="sm-num-lbl">&#127881; {{ $t('Cebinizde-Kalacak') }}</div>
                      <div class="sm-num-val">{{ toplamtutar | moneyformat }}{{ parabirimi | parabirimi }}</div>
                      <div class="sm-num-sub">{{ $t('Bir-Aylik-Bedel-Bedava') }}</div>
                    </div>
                  </div>
                  <div class="sm-arrow">+</div>
                  <div class="sm-num-avg">
                    <div class="sm-avg-stripe"></div>
                    <div class="sm-avg-inner">
                      <div class="sm-num-avg-lbl">{{ $t('Aylik-Maliyet') }}</div>
                      <div class="sm-num-avg-old">{{ toplamtutar | moneyformat }}{{ parabirimi | parabirimi }}</div>
                      <div class="sm-num-avg-val">{{ toplamtutar * 11 / 12 | moneyformat }}{{ parabirimi | parabirimi }}</div>
                      <div class="sm-num-avg-sub">&#8595; {{ $t('Yillik-Bedelini-12ye-Boldu') }}</div>
                    </div>
                  </div>
                </div>
                <div class="sm-action-wrap">
                  <button class="sm-action" @click="switchToYearlyAndGoBack()">
                    &#127873; {{ $t('Yilliga-Gec') }}
                    <small>{{ $t('Hemen-Kazan') }}</small>
                  </button>
                  <span class="sm-no" @click="bannerGizli = true">{{ $t('Hayir-Aylik-Devam-Et') }}</span>
                </div>
              </div>
            </div>

            <!-- Kontör paket yükseltme önerisi -->
            <div v-if="pakettipi === '2' && kontorOneriPaket && !kontorBannerGizli" class="sm-banner">
              <div class="sm-stripe kontor-stripe"></div>
              <div class="sm-inner">

                <div class="sm-left">
                  <div class="sm-icon">&#128293;</div>
                  <div class="sm-body">
                    <strong>{{ $t('Daha-Fazla-Kontor-Al-Daha-Az-Ode') }}</strong>
                    <span>
                      <strong>{{ kontorAdet | fmtInt }}</strong> {{ $t('Kontor-Aliyorsunuz') }}
                      <strong>{{ kontorOneriPaket.qty | fmtInt }}</strong> {{ $t('Kontore-Yukseltin') }}<template v-if="kontorOneriPaket.gift > 0">, <strong>{{ kontorOneriPaket.gift | fmtInt }}</strong> {{ $t('Hediye-Kontor-Kazanin') }}</template>.
                    </span>
                    <div class="sm-pills">
                      <span class="sm-pill" v-if="kontorOneriPaket.gift > 0">&#127873; {{ kontorOneriPaket.gift | fmtInt }} {{ $t('Hediye-Kontor') }}</span>
                      <span class="sm-pill" v-if="kontorOneriPaket.pctSaved > 0">&#128176; %{{ kontorOneriPaket.pctSaved }} {{ $t('Daha-Ucuz') }}</span>
                      <span class="sm-pill">&#128293; {{ $t('Total') }} {{ kontorOneriPaket.total | fmtInt }} {{ $t('Kontor') }}</span>
                    </div>
                  </div>
                </div>

                <div class="sm-numbers">
                  <!-- Mevcut seçim -->
                  <div class="sm-num-card sm-kontor-cur">
                    <div class="sm-num-lbl">{{ $t('Su-Anki-Seciminiz') }}</div>
                    <div class="sm-num-val-cur">{{ kontorAdet | fmtInt }}<span class="sm-num-unit"> {{ $t('Kontor') }}</span></div>
                    <div class="sm-num-sub-cur">{{ toplamtutar | moneyformat }}{{ parabirimi | parabirimi }}</div>
                    <div class="sm-infl">{{ $t('Kontor-Basi') }}<br>
                      <span class="sm-infl-badge sm-infl-blue">{{ kontorBirimFiyat.toFixed(2) }}{{ parabirimi | parabirimi }}</span>
                    </div>
                  </div>

                  <div class="sm-arrow">&#8594;</div>

                  <!-- Önerilen paket -->
                  <div class="sm-num-card sm-save">
                    <div class="sm-save-stripe"></div>
                    <div class="sm-save-inner">
                      <div class="sm-num-lbl">&#9733; {{ $t('Tavsiye-Edilen') }}</div>
                      <div class="sm-num-val sm-num-val-kontor">{{ kontorOneriPaket.qty | fmtInt }}<span class="sm-num-unit"> {{ $t('Kontor') }}</span></div>
                      <div class="sm-num-sub" v-if="kontorOneriPaket.gift > 0">+{{ kontorOneriPaket.gift | fmtInt }} {{ $t('Hediye') }} → <strong>{{ kontorOneriPaket.total | fmtInt }}</strong> {{ $t('Total') }}</div>
                      <div class="sm-num-sub">{{ kontorOneriPaket.price | moneyformat }}{{ parabirimi | parabirimi }}</div>
                    </div>
                  </div>

                  <div class="sm-arrow" v-if="kontorOneriPaket.gift > 0">+</div>
                  <!-- Birim fiyat karşılaştırması -->
                  <div class="sm-num-avg kontor-avg" v-if="kontorOneriPaket.gift > 0">
                    <div class="sm-avg-stripe"></div>
                    <div class="sm-avg-inner">
                      <div class="sm-num-avg-lbl">{{ $t('Kontor-Basi-Maliyet') }}</div>
                      <div class="kontor-avg-old">{{ kontorBirimFiyat.toFixed(2) }}{{ parabirimi | parabirimi }}</div>
                      <div class="sm-num-avg-val kontor-avg-val">{{ kontorOneriPaket.unitReal.toFixed(2) }}{{ parabirimi | parabirimi }}</div>
                      <div class="kontor-pct-badge">&#8595; %{{ kontorOneriPaket.pctSaved }} {{ $t('Daha-Ucuz') }}</div>
                    </div>
                  </div>
                </div>

                <div class="sm-action-wrap">
                  <button class="sm-action" @click="switchToKontorPaket(kontorOneriPaket)">
                    &#128293; {{ $t('Yukselt') }}
                    <small>{{ kontorOneriPaket.total | fmtInt }} {{ $t('Kontor-Al') }}</small>
                  </button>
                  <span class="sm-no" @click="kontorBannerGizli = true">{{ $t('Hayir-Comma') }} {{ kontorAdet | fmtInt }} {{ $t('Kontorde-Devam-Et') }}</span>
                </div>

              </div>
            </div>

            <!-- İki kolonlu ödeme alanı -->
            <div class="odeme-content">

              <!-- SOL PANEL -->
              <div class="odeme-left">

                <!-- Paket özeti -->
                <div class="pkg-summary" v-if="pakettipi === '1' && secilenPaket">
                  <div class="pkg-summary-head">
                    <h3>{{ aylikyillikpaketler === '1' ? $t('Annual') : $t('Monthly') }} {{ alinanUrun }}</h3>
                    <span class="pkg-summary-badge">{{ aylikyillikpaketler === '1' ? $t('Annual') : $t('Monthly') }}</span>
                  </div>
                  <div class="pkg-summary-body">
                    <div class="pkg-row"><span class="pk">&#9992; {{ $t('Ticket') }}</span><span class="pv">{{ secilenPaket.BiletAdet | fmtInt }} {{ $t('Adet') }}</span></div>
                    <div class="pkg-row"><span class="pk">&#127968; Coper</span><span class="pv">{{ secilenPaket.CoperAdet | fmtInt }} {{ $t('Adet') }}</span></div>
                    <div class="pkg-row"><span class="pk">&#128176; {{ $t('Serbest-Cari-Hareket') }}</span><span class="pv">{{ secilenPaket.CariAdet | fmtInt }} {{ $t('Adet') }}</span></div>
                    <div class="pkg-row"><span class="pk">{{ $t('Paket-Tipi') }}</span><span class="pv">{{ aylikyillikpaketler === '1' ? $t('Yillik-Tek-Odeme') : $t('Aylik-Yenileme') }}</span></div>
                    <div class="pkg-row" v-if="aylikyillikpaketler === '1'">
                      <span class="pk">&#127873; {{ $t('Yillik-Tasarruf') }}</span>
                      <span class="pv pv-green">{{ toplamtutar / 11 | moneyformat }}{{ parabirimi | parabirimi }} {{ $t('Tasarruf') }}</span>
                    </div>
                  </div>
                </div>

                <!-- Ödeme yöntemi kartı -->
                <div class="pay-card">
                  <div class="pay-card-head"><span style="font-size:18px">&#128179;</span><h3>{{ $t('Payment-Method') }}</h3></div>

                  <div class="pay-methods">
                    <div class="pay-method" :class="{selected: UrunKayit.OdemeTip==='0'}" @click="UrunKayit.OdemeTip='0'">
                      <span class="pm-ico">&#127981;</span> {{ $t('Transfer-v3') }} / EFT
                      <span class="pm-radio"><span v-if="UrunKayit.OdemeTip==='0'" class="pm-dot"></span></span>
                    </div>
                    <div class="pay-method" :class="{selected: UrunKayit.OdemeTip==='1'}" @click="UrunKayit.OdemeTip='1'">
                      <span class="pm-ico">&#128179;</span> {{ $t('Credit-Card') }}
                      <span class="pm-radio"><span v-if="UrunKayit.OdemeTip==='1'" class="pm-dot"></span></span>
                    </div>
                  </div>

                  <!-- Havale paneli -->
                  <div class="havale-panel" v-if="!kredikarti">
                    <div class="havale-ref">
                      <p>{{ $t('Havale-Aciklama-Pre') }} <strong>{{ $t('Referans-Kodunu') }}</strong> {{ $t('Havale-Aciklama-Mid') }} <strong>"{{ $t('Confirm-Transfer') }}"</strong> {{ $t('Havale-Aciklama-Post') }}</p>
                      <div class="ref-code-row">
                        <div class="ref-code">{{ havaleKodu }}</div>
                      </div>
                    </div>
                    <div class="bank-info">
                      <div class="bank-info-title">&#127981; {{ $t('Banka-Hesap-Bilgileri') }}</div>
                      <div class="bank-field"><span class="bk">{{ $t('Bank') }}</span><span class="bv">GARANTİ BANKASI – Metro Mecidiyeköy Şb.</span></div>
                      <div class="bank-field"><span class="bk">{{ $t('Sube-Kodu') }}</span><span class="bv">723</span></div>
                      <div class="bank-field"><span class="bk">{{ $t('Account-No') }}</span><span class="bv">629 93 38</span></div>
                      <div class="bank-field"><span class="bk">IBAN</span><span class="bv">TR46 0006 2000 7230 0006 2993 38</span></div>
                    </div>
                  </div>

                  <!-- Kredi kartı paneli -->
                  <div class="cc-panel" v-if="kredikarti">
                    <div class="cc-note">
                      <span style="font-size:18px">&#128274;</span>
                      <span v-if="coukAktif">{{ $t('For-Payment-Stripe') }} <strong>STRIPE</strong> {{ $t('For-Payment-Stripe-s2') }}</span>
                      <span v-else>{{ $t('For-Payment-Octet') }} <strong>OCTET</strong> {{ $t('For-Payment-Octet-s2') }}</span>
                    </div>
                    <div class="taksit-wrap" v-if="!coukAktif && seciliozelOran && seciliozelOran.length">
                      <div class="taksit-head">{{ $t('Instalment-Rates') }}</div>
                      <v-radio-group hide-details v-model="secilentaksit" :mandatory="false">
                        <div v-for="item in seciliozelOran" :key="item.TaksitAdet" class="taksit-row">
                          <v-radio :label="item.TaksitLabel" :value="item"></v-radio>
                          <span class="taksit-tutar">{{ item.TaksitTutar | moneyformat }}</span>
                          <span class="taksit-toplam">toplam: {{ item.ToplamTutar | moneyformat }}</span>
                        </div>
                      </v-radio-group>
                    </div>
                    <div class="taksit-wrap" v-if="coukAktif">
                      <div class="taksit-row">
                        <v-radio-group hide-details :mandatory="false" v-model="radioGroup">
                          <v-radio value="1" :label="$t('Lump-Sum')"></v-radio>
                        </v-radio-group>
                        <span class="taksit-tutar">{{ toplamtutar | moneyformat }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SAĞ PANEL -->
              <div class="odeme-right">
                <div class="order-card">
                  <div class="order-card-head"><h3>&#128203; {{ $t('Siparis-Ozeti') }}</h3></div>
                  <div class="order-body">

                    <div class="order-line">
                      <span class="ol">
                        <template v-if="pakettipi === '2'">{{ kontorAdet | fmtInt }} {{ $t('Kontor') }}</template>
                        <template v-else>{{ alinanUrun }} ({{ aylikyillikpaketler === '1' ? $t('Annual') : $t('Monthly') }})</template>
                      </span>
                      <span class="ov">{{ toplamtutar | moneyformat }}{{ parabirimi | parabirimi }}</span>
                    </div>

                    <div class="order-line" v-if="pakettipi === '2' && kontorHediyeAdet > 0">
                      <span class="ol">&#127873; {{ $t('Hediye') }} {{ $t('Kontor') }}</span>
                      <span class="ov pv-green">+{{ kontorHediyeAdet | fmtInt }}</span>
                    </div>
                    <div class="order-line" v-if="pakettipi === '2' && kontorHediyeAdet > 0">
                      <span class="ol"><strong>{{ $t('Total') }} {{ $t('Kontor') }}</strong></span>
                      <span class="ov"><strong>{{ (kontorAdet + kontorHediyeAdet) | fmtInt }}</strong></span>
                    </div>

                    <!-- Yıllık kazanç kutusu -->
                    <div class="yearly-win-box" v-if="aylikyillikpaketler === '1' && pakettipi === '1'">
                      <div class="ywb-stripe"></div>
                      <div class="ywb-inner">
                        <div class="ywb-head">
                          <div class="ywb-head-ico">&#127873;</div>
                          <div class="ywb-head-txt">{{ $t('Yillik-Planla-Kazanciniz') }}</div>
                        </div>
                        <div class="ywb-row">
                          <span class="yw-lbl">{{ $t('12-Ay-Aylik-Odeseydiniz') }}</span>
                          <span class="yw-val yw-muted">{{ toplamtutar / 11 * 12 | moneyformat }}{{ parabirimi | parabirimi }}</span>
                        </div>
                        <div class="ywb-row">
                          <span class="yw-lbl">{{ $t('Yillik-Plan-Fiyati') }}</span>
                          <span class="yw-val">{{ toplamtutar | moneyformat }}{{ parabirimi | parabirimi }}</span>
                        </div>
                        <div class="ywb-divider"></div>
                        <div class="ywb-big">
                          <div class="ywb-big-lbl">{{ $t('Cebinizde-Kalan-Para') }}</div>
                          <div class="ywb-big-val">{{ toplamtutar / 11 | moneyformat }}{{ parabirimi | parabirimi }}</div>
                          <div class="ywb-big-sub">{{ $t('Ayda-Ortalama') }} <strong style="color:#fbbf24">{{ toplamtutar / 12 | moneyformat }}{{ parabirimi | parabirimi }}</strong> {{ $t('Odersiniz') }}</div>
                        </div>
                        <div class="ywb-pills">
                          <span class="ywb-pill">&#127873; {{ $t('Bir-Ay-Tamamen-Bedava') }}</span>
                          <span class="ywb-pill">&#9989; {{ $t('Kesinti-Riski-Yok') }}</span>
                          <span class="ywb-pill">&#128176; {{ $t('En-Dusuk-Aylik-Maliyet') }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="order-total-box" :class="aylikyillikpaketler === '1' && pakettipi === '1' ? 'order-total-yearly' : 'order-total-monthly'">
                      <div class="order-total-lbl">{{ $t('Payment-Amount') }}</div>
                      <div class="order-total-amt">{{ toplamtutar | moneyformat }}{{ parabirimi | parabirimi }}</div>
                      <div class="order-total-sub" v-if="aylikyillikpaketler === '0' || pakettipi === '2'">{{ $t('Kdv-Dahil') }}</div>
                      <div class="order-total-sub" v-if="aylikyillikpaketler === '1' && pakettipi === '1'">&#127881; {{ $t('Aylik-Ort') }} {{ toplamtutar / 12 | moneyformat }}{{ parabirimi | parabirimi }} — {{ $t('Bir-Ay-Bedava-Unlem') }}</div>
                    </div>

                    <div class="contract-check">
                      <input type="checkbox" id="odeme-contract" v-model="sozlesmeOnay">
                      <label for="odeme-contract">
                        <a @click.prevent="sozlesme()" href="#" class="contract-link">{{ $t('On-Bilgilendirme-Kosullari') }}</a> {{ $t('and-lc') }}
                        <a @click.prevent="sozlesme()" href="#" class="contract-link">{{ $t('Mesafeli-Satis-Sozlesmesi') }}</a>{{ $t('Ni-Okudum-Onayliyorum') }}
                      </label>
                    </div>

                    <button class="btn-confirm" :disabled="!sozlesmeOnay" @click="!kredikarti ? SatinAl() : KrediValidate()">
                      <span v-if="!kredikarti">&#127981;</span>
                      <span v-else>&#128179;</span>
                      {{ !kredikarti ? $t('Confirm-Transfer') : $t('Make-Payment') }}
                    </button>

                    <div class="security-row">
                      <div class="sec-item"><span>&#128274;</span> {{ $t('Ssl-Guvenli') }}</div>
                      <div class="sec-item"><span>&#9989;</span> 256-bit</div>
                      <div class="sec-item"><span>&#128203;</span> 3D Secure</div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>

        </v-container>
    </div>

    <v-dialog v-model="dialogOdemeEkUcret" persistent max-width="900px">
      <v-card>
        <v-card-title style="background-color:#01579B">
          <span class="headline white--text">{{ $t('Bilgilendirme') }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <blockquote class="blockquote">{{ $t('info-v1') }}</blockquote>
              <blockquote class="blockquote">{{ $t('info-v2') }}</blockquote>
              <blockquote class="blockquote">{{ $t('info-v3') }}</blockquote>
              <blockquote class="blockquote" style="max-width:800px">{{ $t('info-v4') }}</blockquote>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialogOdemeEkUcret = false">{{ $t('Close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="co-overlay" :class="{open: dialogyenisirket}">
      <div class="co-modal co-modal-stepper" @click.stop>
        <div class="co-modal-head">
          <div class="co-modal-head-icon">&#127970;</div>
          <div style="flex:1">
            <div class="co-modal-title">{{ $t('Add-New-Company') }}</div>
            <div class="co-modal-sub">{{ $t('Firma-Bilgilerini-Eksiksiz-Doldurun') }}</div>
          </div>
          <button class="co-modal-close" type="button" :disabled="ysBekle" @click="sirketaciptal()">&times;</button>
        </div>
        <div class="co-modal-body">
          <v-stepper v-model="ysStep">
            <v-stepper-header>
              <v-stepper-step :complete="ysStep > 1" step="1">{{ $t('Company-Information') }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="ysStep > 2" step="2">{{ $t('Authorized_label') }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="ysStep > 3" step="3">{{ $t('User') }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="4">{{ $t('tab_invoiceinformation') }}</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-form ref="ysForm1" v-model="ysStep1Valid">
                  <v-layout row wrap>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="subtitles" :rules="[ysRules.required]"
                        v-model="ysUnvan" :label="$t('Title_label')" required></v-text-field>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-select prepend-icon="subtitles" item-value="UlkeID" item-text="UlkeAdi"
                        :label="$t('Country-of-Your-Company')" persistent-hint :items="ulkeitems"
                        v-model="secilenUlke" :rules="[ysRules.required]" required></v-select>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-btn color="primary" @click="ysValidate1()" :disabled="!ysStep1Valid">{{ $t('Continue') }}</v-btn>
                <v-btn :disabled="ysBekle" color="info" @click="sirketaciptal()">{{ $t('Return-v2') }}</v-btn>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-form ref="ysForm2" v-model="ysStep2Valid">
                  <v-layout row wrap>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="person" :rules="[ysRules.required]" :placeholder="$t('Name_Surname_label')"
                        v-model="YeniSirketKullanici.AdSoyad" :label="$t('Name_Surname_label')"></v-text-field>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="email" :placeholder="$t('Email_label')" v-model="YeniSirketKullanici.Email"
                        :label="$t('Email_label')" :rules="[ysRules.required, ysRules.email]"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-btn color="primary" @click="ysValidate2()" :disabled="!ysStep2Valid">{{ $t('Continue') }}</v-btn>
                <v-btn color="info" @click="ysStep = 1">{{ $t('GoBack') }}</v-btn>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-form ref="ysForm3" v-model="ysStep3Valid">
                  <v-layout row wrap>
                    <v-flex sm12 md12>
                      <v-alert :type="'error'" :value="true" v-model="ysErrorAlert" transition="scale-transition">
                        <span>{{ ysErrorMsg }}</span>
                      </v-alert>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="lock" counter="8" :placeholder="$t('Password')"
                        v-model="YeniSirketKullanici.Sifre" :label="$t('Password')" :type="ysPwHidden1 ? 'password' : 'text'"
                        :rules="[ysRules.required, ysRules.minLength8]" :append-icon="ysPwHidden1 ? 'visibility' : 'visibility_off'"
                        @click:append="() => (ysPwHidden1 = !ysPwHidden1)"></v-text-field>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="lock" counter="8" :placeholder="$t('Password-Again')" v-model="ysConfirm"
                        :label="$t('Password')" :type="ysPwHidden2 ? 'password' : 'text'" :rules="[ysRules.required, ysRules.minLength8]"
                        :append-icon="ysPwHidden2 ? 'visibility' : 'visibility_off'" @click:append="() => (ysPwHidden2 = !ysPwHidden2)">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-btn color="primary" @click="ysValidate3()" :disabled="!ysStep3Valid">{{ $t('Continue') }}</v-btn>
                <v-btn color="info" @click="ysStep = 2">{{ $t('GoBack') }}</v-btn>
              </v-stepper-content>

              <v-stepper-content step="4">
                <v-form ref="ysForm4" v-model="ysStep4Valid">
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="ysFatUnvan" :label="$t('Title_label') + '*'" required :rules="[ysRules.required]"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model="YeniSirketKullanici.VergiDairesi" :label="$t('Taxcenter_label') + '*'" :rules="[ysRules.required]" required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field v-model="YeniSirketKullanici.VergiNumarasi" :label="$t('Tax-No') + '*'" :rules="[ysRules.required]" required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model="YeniSirketKullanici.MersisNo" :label="$t('Central-Registration-No')"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea v-model="ysFatAcikAdres" :rules="[ysRules.required]" :label="$t('Open-Address')" required rows="2"></v-textarea>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field :label="$t('Postcode_label')" v-model="ysFatPostaKod"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="ysFatSehir" :label="$t('City') + '*'" :rules="[ysRules.required]"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="ysFatIlce" :label="$t('District')"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-autocomplete v-model="ysFatUlke" :items="['Türkiye', 'KKTC']" :label="$t('Country_label')" required :rules="[ysRules.required]"></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-form>

                <div class="ys-loading" v-if="ysBekle">
                  <v-progress-circular indeterminate color="info"></v-progress-circular>
                  <p>{{ ysCurrentMessage }}</p>
                </div>

                <v-layout justify-start>
                  <v-btn :disabled="ysBekle" color="info" @click="ysStep = 3">{{ $t('GoBack') }}</v-btn>
                  <v-btn :disabled="ysBekle" color="info" @click="sirketaciptal()">{{ $t('Cancel') }}</v-btn>
                </v-layout>
                <v-layout justify-end>
                  <v-btn :disabled="ysSaveDisabled" color="info" @click="ysSaveUser()">{{ $t('Firmayi-Onayla-ve-Devam-Et') }}</v-btn>
                </v-layout>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
      </div>
    </div>

    <v-dialog v-model="odemebilgiDialog" persistent max-width="400px">
      <v-card color="grey lighten-5">
        <v-flex pa-2 xs12 sm12 md12>
          <v-form ref="formkredikarti" v-model="validkredikarti" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-alert v-model="alertkredikart" type="error">{{ $t('Complete-details-payment-process') }}</v-alert>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details :label="$t('Name_label')" v-model="PaymentForm.buyerName"></v-text-field>
                <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details :label="$t('Surname_label')" v-model="PaymentForm.buyerSurname"></v-text-field>
                <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details :label="$t('GSM')" v-model="PaymentForm.buyerMobilePhone"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click.native="odemebilgiDialog=false">{{ $t('Cancel') }}</v-btn>
          <v-btn color="info" flat @click="KrediValidate()">{{ $t('Continue-the-process') }}</v-btn>
          <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogurunDetay" max-width="460px">
      <div class="det-modal">
        <div class="det-mhead">
          <span class="det-mtitle">{{ urunDetay.PaketAdi }} {{ $t('Package-features') }}</span>
          <button class="det-mclose" @click="dialogurunDetay=false">&times;</button>
        </div>
        <table class="det-mtbl">
          <thead>
            <tr>
              <th>{{ $t('Program-Type') }}</th>
              <th>{{ $t('Number') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in detayRows" :key="row.key">
              <td><span class="det-mfi">{{ row.icon }}</span>{{ row.label }}</td>
              <td>{{ row.value | fmtInt }}</td>
            </tr>
          </tbody>
        </table>
        <p class="det-mnote">*** {{ $t('package-limits-need-to-buy') }}</p>
      </div>
    </v-dialog>

    <v-dialog v-model="upsellDialog" max-width="480px">
      <div class="ups-modal" v-if="upsellPending && upsellRec">
        <div class="ups-hdr" :class="upsellPending.type === 'paket' ? 'ups-hdr-navy' : ''">
          <button class="ups-close-btn" @click="upsellClose()">×</button>
          <div class="ups-hdr-ico">🎉</div>
          <h2 class="ups-hdr-title">
            <template v-if="upsellPending.type === 'kontor'">{{ $t('Az-Bir-Farkla-Cok-Daha-Fazlasini') }}</template>
            <template v-else>{{ $t('Yillik-Plana-Gecin-Bir-Ay-Bedava') }}</template>
          </h2>
          <p class="ups-hdr-sub">
            <template v-if="upsellPending.type === 'kontor'">
              {{ upsellPending.qty | fmtInt }} {{ $t('Ups-Kontor-Sectiniz-Pre') }} {{ upsellRec.priceDiff | moneyformat }}{{ parabirimi | parabirimi }} {{ $t('Ups-Kontor-Sectiniz-Mid') }} {{ upsellRec.qty | fmtInt }} {{ $t('Kontor') }} + {{ upsellRec.gift | fmtInt }} {{ $t('Ups-Kontor-Sectiniz-Post') }}
            </template>
            <template v-else>
              {{ $t('Ups-Aylik-Toplam-Pre') }} {{ upsellPending.price * 12 | moneyformat }}{{ parabirimi | parabirimi }} {{ $t('Ups-Aylik-Toplam-Mid') }} {{ upsellRec.saving | moneyformat }}{{ parabirimi | parabirimi }} {{ $t('Ups-Aylik-Toplam-Post') }}
            </template>
          </p>
        </div>

        <div class="ups-body">
          <div class="ups-compare">
            <div class="ups-box ups-cur-box">
              <div class="ups-box-lbl">{{ $t('Sectiginiz') }}</div>
              <div class="ups-box-qty">
                <template v-if="upsellPending.type === 'kontor'">{{ upsellPending.qty | fmtInt }} {{ $t('Kontor') }}</template>
                <template v-else>{{ upsellPending.item.PaketAdi }}<br><span class="ups-box-sub">{{ $t('Aylik-Plan') }}</span></template>
              </div>
              <div class="ups-box-price">{{ upsellPending.price | moneyformat }}{{ parabirimi | parabirimi }}</div>
            </div>

            <div class="ups-cmp-arrow">→</div>

            <div class="ups-box ups-rec-box">
              <div class="ups-box-lbl ups-rec-lbl">{{ $t('Onerilen') }}</div>
              <div class="ups-box-qty ups-rec-qty">
                <template v-if="upsellPending.type === 'kontor'">{{ upsellRec.qty | fmtInt }} {{ $t('Kontor') }}</template>
                <template v-else>{{ upsellRec.item.PaketAdi }}<br><span class="ups-box-sub ups-box-sub-green">{{ $t('Yillik-Plan') }}</span></template>
              </div>
              <div v-if="upsellPending.type === 'kontor'" class="ups-gift-pill">
                🎁 +{{ upsellRec.gift | fmtInt }} {{ $t('Hediye') }} — {{ $t('Total') }} {{ upsellRec.total | fmtInt }}
              </div>
              <div v-else class="ups-gift-pill">🎁 {{ $t('Bir-Ay-Bedava-Kucuk') }}</div>
              <div class="ups-box-price">{{ upsellRec.price | moneyformat }}{{ parabirimi | parabirimi }}</div>
            </div>
          </div>

          <div class="ups-diff-box">
            <div class="ups-diff-main">
              <template v-if="upsellPending.type === 'kontor'">{{ $t('Sadece') }} {{ upsellRec.priceDiff | moneyformat }}{{ parabirimi | parabirimi }} {{ $t('Fark') }}</template>
              <template v-else>{{ upsellRec.saving | moneyformat }}{{ parabirimi | parabirimi }} {{ $t('Tasarruf-Buyuk') }}</template>
            </div>
            <div class="ups-diff-sub">
              <template v-if="upsellPending.type === 'kontor'">{{ $t('Ups-Bu-Farki-Odeyerek-Pre') }} {{ (upsellRec.total - upsellPending.qty) | fmtInt }} {{ $t('Ups-Bu-Farki-Odeyerek-Post') }}</template>
              <template v-else>{{ $t('Ups-Yillik-Planla-Tasarruf') }}</template>
            </div>
          </div>

          <div class="ups-unit-box" v-if="upsellPending.type === 'kontor'">
            <div class="ups-unit-top">
              <span class="ups-unit-lbl">{{ $t('Kontor-Basi-Fiyat-Buyuk') }}</span>
              <span class="ups-unit-pct">-%{{ upsellRec.pctSaved }}</span>
            </div>
            <div class="ups-unit-row">
              <div class="ups-unit-cur">
                <span class="ups-unit-cur-val">{{ upsellPending.unitPrice.toFixed(2) }}{{ parabirimi | parabirimi }}</span>
                <span class="ups-unit-cur-lbl">{{ $t('Su-Anki') }}</span>
              </div>
              <span class="ups-unit-arr">▶</span>
              <div class="ups-unit-new">
                <span class="ups-unit-new-val">{{ upsellRec.unitReal.toFixed(2) }}{{ parabirimi | parabirimi }}</span>
                <span class="ups-unit-new-lbl">{{ $t('Onerilen-Pakette') }}</span>
              </div>
            </div>
          </div>

          <button class="ups-btn-yes" @click="upsellAccept()">
            🎁 <template v-if="upsellPending.type === 'kontor'">{{ $t('Evet-Hediyeli-Paketi-Almak-Istiyorum') }}</template>
            <template v-else>{{ $t('Evet-Yillik-Plana-Gecmek-Istiyorum') }}</template>
          </button>
          <button class="ups-btn-no" @click="upsellDecline()">
            <template v-if="upsellPending.type === 'kontor'">{{ $t('Hayir-Sectigim-Kontor-Adedini-Almak-Istiyorum') }}</template>
            <template v-else>{{ $t('Hayir-Aylik-Devam-Etmek-Istiyorum') }}</template>
          </button>
        </div>
      </div>
    </v-dialog>

    <v-snackbar :timeout="timeout" :top="y==='top'" :bottom="y==='bottom'" :right="x==='right'"
      :left="x==='left'" :multi-line="mode==='multi-line'" :vertical="mode==='vertical'" v-model="snackbar">
      {{ text1 }}
      <v-btn flat color="pink" @click.native="snackbar=false">{{ $t('Close') }}</v-btn>
    </v-snackbar>

  </div>
</template>

<script>
  import { StripeCheckout } from '@vue-stripe/vue-stripe';
  import auth from '../../../api/auth'
  import _ from 'underscore'
  import router from '../../../router'
  import genelsatissozlesme from "@/components/app/customcomp/genelsatissozlesme.vue"
  import altaciklama from "@/components/app/account/altaciklama.vue"
  import axios from 'axios'
  import helpers from "@/components/app/customcomp/helpers.js"
  import navi from "@/components/app/account/navigator.vue"
  import $ from '@/plugins/i18n.js'
  import { Trans } from '@/plugins/Translation'

  export default {
    data() {
      this.publishableKey = 'pk_test_51Qi6HsBMw00zPru8pBIuLpW4lHnr2o0z1JHrFOrrJBA6uFmqvdhFnrC2V74rjvVQauAx893KhE8oHRJynyZaeUx200Ufsr2YcJ';
      return {
        activeSection: 'paketler',
        kpkgDefs: [
          { qty: 100,  gift: 0,    feat: false },
          { qty: 500,  gift: 0,    feat: false },
          { qty: 1000, gift: 300,  feat: false },
          { qty: 2000, gift: 800,  feat: true  },
          { qty: 5000, gift: 2500, feat: false },
        ],

        dot9Aktif: false,
        tursabUyariDialog: false,
        e1: 0,
        tursabSartlarDialog: false,
        tursabCardDialog: false,
        sonkullanimAy: [
          { id: '01', text: '1' }, { id: '02', text: '2' }, { id: '03', text: '3' },
          { id: '04', text: '4' }, { id: '05', text: '5' }, { id: '06', text: '6' },
          { id: '07', text: '7' }, { id: '08', text: '8' }, { id: '09', text: '9' },
          { id: '10', text: '10' }, { id: '11', text: '11' }, { id: '12', text: '12' },
        ],
        sonkullanimYil: [
          '2020','2021','2022','2023','2024','2025','2026','2027','2028',
          '2029','2030','2031','2032','2033','2034','2035','2036','2037','2038','2039','2040'
        ],
        validOdeme: true,
        tursabcard: {
          Id: null, CardHolder: null, CardNumber: null, Cvv: null,
          ExpirationYear: null, ExpirationMonth: null, MobilePhone: null,
          VirtualPosId: null, InstallmentCount: null, tursabbelgeno: null,
        },
        loadingdialog: false,
        lineItems: [{ price: 'price_1QldYSBMw00zPru8J0DUTkWd', quantity: 1 }],
        radioGroup: '1',
        coukAktif: false,
        successURL: 'https://next.arkman.co.uk/#/account/urunler/id',
        cancelURL: 'https://next.arkman.co.uk/#/account/urunler/id',
        isModalOpen: false,
        errorMessage: '',
        tursabtoken: '',
        tursaburun: null,
        tursabgoster: true,
        kayitliFatAdres: '',
        fatUnvan: '', fatVergiDairesi: '', fatVergiNo: '', fatUlke: '',
        fatSehir: '', fatIlce: '', fatPostaKod: '', fatAcikAdres: '',
        isFatValid: false,
        fatDialog: false,
        secilenTaskit3d: null,
        alertkredikart: true,
        odemebilgiDialog: false,
        validkredikarti: true,
        octetKrediKartiDialog: false,
        octetReturnUrl: null,
        alinanUrun: null,
        alinanAdet: 1,
        sozlesmeOnay: false,
        aylikyillikpaketler: '0',
        ulkeitems: [],
        secilenUlke: 1,
        tekkontorFiyat: 0,
        toplamkontorFiyat: 0,
        kontorAdet: 1,
        kontorHediyeAdet: 0,
        urunDetay: {
          Aktif: null, BaslangicTarih: null, BitisTarih: null,
          CariAdet: null, CoperAdet: null, CoperIptalAdet: null,
          DonemAdet: null, FaturaAdet: null, Fiyat: null,
          IadeAdet: null, IndirimliFiyat: null, MusteriID: null,
          PaketAdi: null, PaketID: null, PaketTip: null,
          ToplamAdet: null, VizeAdet: null, VoidAdet: null,
        },
        dialogurunDetay: false,
        havaleKodu: null,
        ozelOranlar: [],
        seciliozelOran: null,
        secilentaksit: null,
        musteriidurun: null,
        pass: null,
        yedekresponse: [],
        bekle: false,
        AnaSirketlerWiev: [],
        AnaSirketler: [],
        Sirketler: [],
        AnaSirket: {},
        Sirket: {},
        giris: true,
        Urunler: false,
        urunlerlist: [],
        active: false,
        pakettipi: '1',
        productshow: [],
        havale: true,
        kredikarti: false,
        odemeekrani: false,
        secilenPaket: null,
        bannerGizli: false,
        kontorBannerGizli: false,
        upsellDialog: false,
        upsellPending: null,
        upsellRec: null,
        toplamtutar: 0,
        urunekrani: true,
        musteriid: null,
        dialogyenisirket: false,
        dialogOdemeEkUcret: false,
        ysStep: 1,
        ysStep1Valid: true,
        ysStep2Valid: true,
        ysStep3Valid: true,
        ysStep4Valid: true,
        ysBekle: false,
        ysPwHidden1: true,
        ysPwHidden2: true,
        ysErrorAlert: false,
        ysErrorMsg: '',
        ysMessages: [
          this.$t('Ys-Msg-Sirket-Olusturuluyor'),
          this.$t('Ys-Msg-Calismaya-Devam'),
          this.$t('Ys-Msg-Tesekkurler'),
          this.$t('Ys-Msg-Hos-Geldiniz'),
        ],
        ysCurrentMessage: '',
        ysMessageInterval: null,
        ysUnvan: null,
        ysConfirm: null,
        ysFatUnvan: '',
        ysFatUlke: '',
        ysFatSehir: '',
        ysFatIlce: '',
        ysFatPostaKod: '',
        ysFatAcikAdres: '',
        YeniSirketKullanici: {
          UserID: null, MusteriID: 0, KullaniciAdi: null, Email: null, Sifre: null, Tip: 0, AdSoyad: null,
          Deleted: false, Aktif: true, MusteriBilgi: [], ProgramTip: 0, VergiNumarasi: '', VergiDairesi: '', MersisNo: '',
        },
        ysRules: {
          required: (value) => !!value || this.$t('Mandatory-Areas'),
          email: (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || this.$t('Wrong-e-mail')
          },
          minLength8: (value) => (!!value && value.length >= 8) || this.$t('Sifre-En-Az-8-Karakter'),
        },
        sirkettipi: '0',
        mevcutsirketmi: true,
        yenisirket: false,
        dialog: false,
        faturainfo: [],
        newuserstatus: false,
        loginstatus: true,
        e2: true, e3: true, e4: true,
        text1: '',
        snackbar: false,
        y: 'top', x: 'right', mode: '', timeout: 6000,
        parabirimi: null,
        cardimageLink: 'https://param.com.tr/images/banka/diger_kredi_kart.png',
        cardimageLinkyedek: 'https://param.com.tr/images/banka/diger_kredi_kart.png',
        binResult: { Bin: null, Dkk: null, KartBanka: null, KartOrg: null, KartTip: null, SanalPosId: null },
        MusteriUrun: {
          ID: null, MusteriID: null,
          PaketBilgi: { PaketID: null, PaketTip: null },
          OdemeBilgi: { ID: null, OdemeTip: 0, OdemeOnay: false },
          BaslangicTarih: null, BitisTarihi: null,
          KontorAdet: 0, KalanKontorAdet: 0,
          BiletAdet: 0, FaturaAdet: 0, CariAdet: 0,
          IadeAdet: 0, VoidAdet: 0, CoperAdet: 0, CoperIptalAdet: 0, VizeAdet: 0,
        },
        UrunKayit: {
          ID: null, Aciklama: null, OdemeTip: '0', OdemeOnay: false,
          Tarih: null, Tutar: 0, Banka: null, TaksitAdet: null,
          VadeFarki: null, VadeTarihi: null, CariKod: null,
          FaturaTarihi: null, FaturaSeri: null, FaturaNo: null,
          IslemID: null, GuID: null, SiparisID: null, DekontID: null, UlkeID: null,
        },
        PaymentForm: {
          action: 'CREATE_COMMON_PAYMENT_PAGE_REQUEST',
          partnerCode: auth.OCTET_API_PARTNER_CODE,
          paymentAmount: 0, currency: 'TRY',
          expireDateTime: '', expireDateShowText: '',
          buyerName: null, buyerSurname: null, buyerMobilePhone: null,
          buyerEmail: null, buyerTCKN: 0, buyerCompanyName: '',
          returnPage: null, buyerTaxOffice: '', buyerTaxNumber: '',
          language: 'TR', apiReferenceID: '', apiReferenceInfo: '',
          sellerReference: '', consumerCardInstallmentLimit: '',
          commercialCardInstallmentLimit: '', secretKey: null, refId: null,
        },
        clipped: true, drawer: false, fixed: false, miniVariant: false,
        right: true, rightDrawer: false,
        valid: true, validOdeme2: true, errorMsg: '', errorAlert: false,
      };
    },

    computed: {
      ysSaveDisabled() {
        return this.ysBekle || !this.ysStep4Valid;
      },
      kontorUrun() {
        return this.urunlerlist.find(e => e.PaketTip == 2 && e.PaketID != 148) || null;
      },
      kontorBirimFiyat() {
        return this.kontorUrun ? this.kontorUrun.Fiyat : 17.49;
      },
      kpkgList() {
        const bp = this.kontorBirimFiyat;
        return this.kpkgDefs.map(k => {
          const price    = k.qty * bp;
          const total    = k.qty + k.gift;
          const unitStd  = bp;
          const unitReal = k.gift > 0 ? price / total : bp;
          const pctSaved = k.gift > 0 ? Math.round(((unitStd - unitReal) / unitStd) * 100) : 0;
          return { ...k, price, total, unitStd, unitReal, pctSaved };
        });
      },
      monthlyItems() {
        return this.urunlerlist.filter(e => e.PaketTip == 1 && e.DonemAdet == 1 && e.PaketID != 148 && e.PaketID != 160);
      },
      yearlyItems() {
        return this.urunlerlist.filter(e => e.PaketTip == 1 && e.DonemAdet == 12 && e.PaketID != 148 && e.PaketID != 160);
      },
      maxYearlyTasarruf() {
        let max = 0;
        this.yearlyItems.forEach((y, idx) => {
          const m = this.monthlyItems[idx];
          if (m) { const save = (m.Fiyat * 12) - y.Fiyat; if (save > max) max = save; }
        });
        return max;
      },
      kontorOneriPaket() {
        if (this.pakettipi !== '2') return null;
        const adet = parseInt(this.kontorAdet) || 0;
        if (adet >= 5000) return null;
        return this.kpkgList.find(k => k.qty > adet) || null;
      },
      featuredIndex() {
        return Math.floor((this.productshow.length - 1) / 2);
      },
      detayRows() {
        return [
          { key: 'bilet',   icon: '✈',  label: this.$t('Number-of-Tickets'),              value: this.urunDetay.BiletAdet },
          { key: 'void',    icon: '🚫', label: this.$t('Number-of-Void'),                 value: this.urunDetay.VoidAdet },
          { key: 'iade',    icon: '↩',  label: this.$t('Number-of-Refunds'),              value: this.urunDetay.IadeAdet },
          { key: 'coper',   icon: '🏨', label: this.$t('Number-of-Coper-PNRs'),           value: this.urunDetay.CoperAdet },
          { key: 'coperip', icon: '✕',  label: this.$t('Number-of-Coper-PNRs-Cancelled'), value: this.urunDetay.CoperIptalAdet },
          { key: 'vize',    icon: '📄', label: this.$t('Number-of-Visas'),                value: this.urunDetay.VizeAdet },
          { key: 'cari',    icon: '💰', label: this.$t('Current-Number'),                 value: this.urunDetay.CariAdet },
          { key: 'fatura',  icon: '🧾', label: this.$t('Invoice-Number'),                 value: this.urunDetay.FaturaAdet },
        ];
      },
    },

    methods: {
      switchSection(section) {
        this.activeSection = section;
        this.pakettipi = section === 'paketler' ? '1' : '2';
      },

      callLisans() {
        alert(this.$t('Lisans-Bilgisi-Icin-Arayin'));
      },

      buyKPkg(k) {
        if (!this.kontorUrun) { this.text1 = this.$t('Kontor-Urunu-Bulunamadi'); this.snackbar = true; return; }
        if (k.qty < 5000) {
          const next = this.kpkgList.find(p => p.qty > k.qty && p.gift > 0);
          if (next) {
            this.upsellPending = { type: 'kontor', qty: k.qty, price: k.price, unitPrice: this.kontorBirimFiyat, item: this.kontorUrun, adet: k.qty, gift: k.gift };
            this.upsellRec = { ...next, priceDiff: next.price - k.price, item: this.kontorUrun, adet: next.qty };
            this.upsellDialog = true;
            return;
          }
        }
        this.kontorAdet = k.qty;
        this.Odeme(this.kontorUrun, k.qty, k.gift);
      },

      buyCustomKontor() {
        if (!this.kontorUrun) { this.text1 = this.$t('Kontor-Urunu-Bulunamadi'); this.snackbar = true; return; }
        const adet = parseInt(this.kontorAdet) || 1;
        if (adet < 5000) {
          const next = this.kpkgList.find(p => p.qty > adet && p.gift > 0);
          if (next) {
            const curPrice = adet * this.kontorBirimFiyat;
            this.upsellPending = { type: 'kontor', qty: adet, price: curPrice, unitPrice: this.kontorBirimFiyat, item: this.kontorUrun, adet, gift: 0 };
            this.upsellRec = { ...next, priceDiff: next.price - curPrice, item: this.kontorUrun, adet: next.qty };
            this.upsellDialog = true;
            return;
          }
        }
        this.Odeme(this.kontorUrun, adet, 0);
      },

      buyPaketCheck(item) {
        if (this.aylikyillikpaketler === '1') { this.Odeme(item, 1); return; }
        const idx = this.monthlyItems.findIndex(e => e.PaketID === item.PaketID);
        const yearlyItem = idx !== -1 ? this.yearlyItems[idx] : null;
        if (!yearlyItem) { this.Odeme(item, 1); return; }
        this.upsellPending = { type: 'paket', price: item.Fiyat, item, adet: 1 };
        this.upsellRec = { type: 'paket', price: yearlyItem.Fiyat, saving: (item.Fiyat * 12) - yearlyItem.Fiyat, item: yearlyItem, adet: 1 };
        this.upsellDialog = true;
      },

      upsellClose() {
        this.upsellDialog = false;
        this.upsellPending = null;
        this.upsellRec = null;
      },
      upsellAccept() {
        const rec = this.upsellRec;
        this.upsellClose();
        if (!rec) return;
        if (rec.type === 'paket') this.aylikyillikpaketler = '1';
        this.Odeme(rec.item, rec.adet, rec.gift);
      },
      upsellDecline() {
        const p = this.upsellPending;
        this.upsellClose();
        if (!p) return;
        this.Odeme(p.item, p.adet, p.gift);
      },

      SartlarKabul() {
        this.tursabSartlarDialog = false;
        this.tursabCardDialog = true;
      },
      tursabcardialogac() {
        var m1 = localStorage.getItem('active');
        if (m1 != null && m1 != '0') { this.tursabUyariDialog = true; return; }
        if (this.sirkettipi == '0' && this.AnaSirket != null && this.AnaSirket && typeof(this.sirkettipi) != 'object') {
          this.tursabSartlarDialog = true;
        } else {
          this.text1 = this.$t('Please-select-a-company'); this.snackbar = true;
        }
      },
      tursabcardialogkapat() { this.tursabCardDialog = false; },
      tursabgettoken() {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        const urlencoded = new URLSearchParams();
        urlencoded.append("grant_type", "client_credentials");
        urlencoded.append("client_id", "2c71f2c6-54b3-4832-95c5-b5cd86d4432b");
        urlencoded.append("client_secret", "85aaeb64-6d68-4429-9f5f-b71d396caacd");
        urlencoded.append("scope", "TursabCard");
        fetch("https://api2.tursab.org.tr/token", { method: "POST", headers: myHeaders, body: urlencoded })
          .then(r => r.json())
          .then(result => { this.tursabtoken = result.access_token; this.tursabvalidatecard(); })
          .catch(e => console.error(e));
        return true;
      },
      tursabvalidatecard() {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", "Bearer " + this.tursabtoken);
        const raw = JSON.stringify({
          nameOnCard: this.tursabcard.CardHolder, tursabNo: this.tursabcard.tursabbelgeno,
          cardNumber: this.tursabcard.CardNumber, expireMonth: this.tursabcard.ExpirationMonth,
          expireYear: this.tursabcard.ExpirationYear, cvv: this.tursabcard.Cvv,
        });
        fetch("https://api2.tursab.org.tr/v1/tursabcard/validatecard", { method: "POST", headers: myHeaders, body: raw })
          .then(r => r.json())
          .then(result => {
            if (result.success == true) {
              this.text1 = this.$t('Kart-Dogrulama-Basarili'); this.snackbar = true;
              this.tursaburungit(); this.tursabCardDialog = false;
            } else {
              this.text1 = this.$t('Kart-Dogrulama-Yapilamadi'); this.snackbar = true;
            }
          })
          .catch(e => console.error(e));
      },
      tursabcarddogrula() {
        if (this.sirkettipi == '0' && this.AnaSirket != null && this.AnaSirket && typeof(this.sirkettipi) != 'object') {
        } else {
          this.text1 = this.$t('Please-select-a-company'); this.snackbar = true; return;
        }
        if (!this.tursabcard.CardHolder || !this.tursabcard.CardNumber || !this.tursabcard.ExpirationYear || !this.tursabcard.tursabbelgeno) {
          this.text1 = this.$t('Kart-Dogrulama-Tum-Alanlar'); this.snackbar = true; return;
        }
        this.tursabgettoken();
      },
      greet() { this.fatDialog = true; },
      sozlesme() {
        this.$refs.genelsatissozlesme.open(this.AnaSirket, this.alinanUrun, this.alinanAdet).then(() => {});
      },
      getimage(a) { return helpers.getimage(a); },
      urundetayGetir(val) { this.dialogurunDetay = true; this.urunDetay = val; },
      KrediValidate() {
        if (this.sozlesmeOnay == true) {
          if (this.PaymentForm.buyerName != null && this.PaymentForm.buyerSurname != null && this.PaymentForm.buyerMobilePhone != null) {
            this.KrediOdemeYap(); this.odemebilgiDialog = false;
          } else {
            var ml = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
            if (ml != null) {
              if (ml.UserInfo.GSM != null && ml.UserInfo.GSM != '') {
                this.PaymentForm.buyerMobilePhone = ml.UserInfo.GSM;
                this.PaymentForm.buyerName = ml.UserInfo.AdSoyad;
                this.PaymentForm.buyerSurname = ml.UserInfo.AdSoyad;
                this.PaymentForm.buyerEmail = ml.UserInfo.Email;
              }
            }
            if (this.PaymentForm.buyerName != null && this.PaymentForm.buyerSurname != null && this.PaymentForm.buyerMobilePhone != null) {
              this.KrediOdemeYap(); this.odemebilgiDialog = false;
            } else { this.odemebilgiDialog = true; }
          }
        } else { this.text1 = this.$t('You-need-approve-contract'); this.snackbar = true; }
      },
      KrediOdemeYapeski() {
        const toplamKontor = this.kontorAdet + this.kontorHediyeAdet;
        if (this.coukAktif) {
          var packageObject = {
            musteriid: this.musteriidurun, paketid: this.MusteriUrun.PaketBilgi.PaketID,
            pakettip: this.pakettipi, Acikklama: 'stripe', Tutar: this.UrunKayit.Tutar,
            UlkeID: 0, kontoradet: toplamKontor,
          };
          localStorage.setItem('po', JSON.stringify(packageObject));
          this.successURL = 'https://next.arkman.co.uk/#/customcomp/stripereturn';
          this.loadingdialog = true;
          this.$refs.checkoutRef.redirectToCheckout();
          return;
        }
        this.PaymentForm.paymentAmount = helpers.roundNumber(this.toplamtutar, 2);
        this.PaymentForm.refId = this.defaultKod(8);
        this.PaymentForm.apiReferenceID = this.defaultKod(8);
        this.PaymentForm.sellerReference = ("MID=" + this.musteriidurun + " PID=" + this.MusteriUrun.PaketBilgi.PaketID + " PTip=" + this.pakettipi + " KAdet=" + toplamKontor + " PAdi=" + this.alinanUrun).substring(0, 49);
        if (this.secilentaksit != null) {
          const t = this.secilentaksit.TaksitAdet;
          this.PaymentForm.consumerCardInstallmentLimit = t || 1;
          this.PaymentForm.commercialCardInstallmentLimit = t || 1;
        } else {
          this.PaymentForm.consumerCardInstallmentLimit = 1;
          this.PaymentForm.commercialCardInstallmentLimit = 1;
        }
        this.PaymentForm.buyerTCKN = '11111111111';
        this.PaymentForm.returnPage = 'https://nextapiv2.arkman.com.tr/OctetView/Index/?&musteriid=' + this.musteriidurun + '&paketid=' + this.MusteriUrun.PaketBilgi.PaketID + '&pakettip=' + this.pakettipi + '&kontoradet=' + toplamKontor + '&urunaciklama=' + this.alinanUrun;
        var queryadres = "api/Payment/OctetRequest";
        if (this.dot9Aktif) { this.PaymentForm.partnerCode = "ARKMANBILGISAYARTEST"; queryadres = "api/Payment/OctetRequestv3_Test"; }
        this.$http.post(auth.API_URL + queryadres, this.PaymentForm, { headers: {} }).then(response => {
          if (response.body.Status) {
            this.octetReturnUrl = response.body.Data.resultData.commonPaymentPageURL;
            if (this.dot9Aktif) { window.location.href = this.octetReturnUrl; } else { this.octetKrediKartiDialog = true; }
          } else { this.text1 = this.$t(response.body.ResponseMessage); this.snackbar = true; }
        }, () => { this.text1 = 'Service Unavailable-KartOde'; this.snackbar = true; });
      },
       KrediOdemeYap() {
            console.log(window.location.host);
            const toplamKontor = this.kontorAdet + this.kontorHediyeAdet;
            if (this.coukAktif)
            {
                var packageObject={
                    musteriid:this.musteriidurun,
                    paketid:this.MusteriUrun.PaketBilgi.PaketID,
                    pakettip:this.pakettipi,
                    Acikklama:'stripe',
                    Tutar:this.UrunKayit.Tutar,
                    UlkeID:0,
                    kontoradet:this.kontoradet
                }
                localStorage.setItem('po',JSON.stringify(packageObject));
                
                this.successURL='https://next.arkman.co.uk/#/customcomp/stripereturn'
                this.loadingdialog=true;
                this.$refs.checkoutRef.redirectToCheckout();
                return;
            }

               

                this.PaymentForm.paymentAmount = helpers.roundNumber(this.toplamtutar, 2);
                this.PaymentForm.refId = this.defaultKod(8);
                this.PaymentForm.apiReferenceID=this.defaultKod(8)
                this.PaymentForm.sellerReference = "MID=" +this.musteriidurun + " PID=" + this.MusteriUrun.PaketBilgi.PaketID + " PTip=" +  this.pakettipi + " KAdet=" + toplamKontor + " PAdi=" + this.alinanUrun
                if(this.PaymentForm.sellerReference.length > 50){
                        this.PaymentForm.sellerReference = this.PaymentForm.sellerReference.substring(0,49)
                }
                
                if (this.secilentaksit != null) {
                    if (this.secilentaksit.TaksitAdet != 0 && this.secilentaksit.TaksitAdet != null) {
                        this.PaymentForm.consumerCardInstallmentLimit = this.secilentaksit.TaksitAdet
                         this.PaymentForm.commercialCardInstallmentLimit = this.secilentaksit.TaksitAdet
                    } else {
                        this.PaymentForm.consumerCardInstallmentLimit = 1;
                         this.PaymentForm.commercialCardInstallmentLimit=1;
                    }
                } else {
                    this.PaymentForm.consumerCardInstallmentLimit = 1;
                     this.PaymentForm.commercialCardInstallmentLimit=1;
                }
               this.PaymentForm.buyerTCKN='11111111111';
               this.PaymentForm.returnPage='https://nextapiv2.arkman.com.tr/OctetView/Index/?&musteriid='+this.musteriidurun+'&paketid='+this.MusteriUrun.PaketBilgi.PaketID+'&pakettip='+this.pakettipi+'&kontoradet='+toplamKontor+'&urunaciklama='+this.alinanUrun
                 //this.PaymentForm.returnPage='http://localhost:9001/OctetView/Index/?&musteriid='+this.musteriidurun+'&paketid='+this.MusteriUrun.PaketBilgi.PaketID+'&pakettip='+this.pakettipi+'&kontoradet='+toplamKontor+'&urunaciklama='+this.alinanUrun

                 var queryadres="api/Payment/OctetRequest"
                  this.PaymentForm.partnerCode="ARKMANBILGISAYAR";
//                  if (this.dot9Aktif){
//                     this.PaymentForm.partnerCode="ARKMANBILGISAYARTEST";
// queryadres="api/Payment/OctetRequestv3_Test";
//                  }
if (this.PaymentForm.buyerMobilePhone!=null){
    this.PaymentForm.buyerMobilePhone = this.PaymentForm.buyerMobilePhone
    .replaceAll(" ", "")
    .replaceAll("-", "")
    .replaceAll("(", "")
    .replaceAll(")", "");
}else{
   
}
 this.PaymentForm.buyerMobilePhone='05321111111';
                var params2 = this.PaymentForm
                this.$http.post(auth.API_URL + queryadres, params2, {
                    headers: {}
                }).then((response) => {

                    if (response.body.Status) {
                         this.octetReturnUrl = response.body.Data.resultData.commonPaymentPageURL
//                         if (this.dot9Aktif){
//  window.location.href = response.body.Data.resultData.commonPaymentPageURL;
//                         }else{
//  this.octetKrediKartiDialog = true
//                         }
                        window.location.href = response.body.Data.resultData.commonPaymentPageURL;
                        console.log(this.PaymentForm.returnPage);
                       
                       
                       
                    } else {
                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true
                    }

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-KartOde'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-KartOde'
                        this.snackbar = true
                    }
                })

            },
      logout() { auth.logout(); },
      openNewCoModal() { this.ysResetForm(); this.dialogyenisirket = true; },
      sirketaciptal() {
        if (this.ysBekle) { return; }
        this.dialogyenisirket = false; this.sirkettipi = '0'; this.ysStopLoading(); this.ysResetForm();
      },
      ysResetForm() {
        this.ysStep = 1; this.ysErrorAlert = false; this.ysErrorMsg = '';
        this.ysUnvan = null; this.ysConfirm = null;
        this.ysFatUnvan = ''; this.ysFatUlke = ''; this.ysFatSehir = ''; this.ysFatIlce = '';
        this.ysFatPostaKod = ''; this.ysFatAcikAdres = '';
        this.YeniSirketKullanici = {
          UserID: null, MusteriID: 0, KullaniciAdi: null, Email: null, Sifre: null, Tip: 0, AdSoyad: null,
          Deleted: false, Aktif: true, MusteriBilgi: [], ProgramTip: 0, VergiNumarasi: '', VergiDairesi: '', MersisNo: '',
        };
        if (this.$refs.ysForm1) { this.$refs.ysForm1.reset(); }
        if (this.$refs.ysForm2) { this.$refs.ysForm2.reset(); }
        if (this.$refs.ysForm3) { this.$refs.ysForm3.reset(); }
        if (this.$refs.ysForm4) { this.$refs.ysForm4.reset(); }
      },
      ysValidate1() { if (this.$refs.ysForm1.validate) { this.ysStep = 2; } },
      ysValidate2() { if (this.$refs.ysForm2.validate) { this.ysStep = 3; } },
      ysValidate3() {
        if (this.YeniSirketKullanici.Sifre !== this.ysConfirm) {
          this.ysErrorAlert = true; this.ysErrorMsg = this.$t('Passwords-do-not-match');
          return;
        }
        this.ysErrorAlert = false;
        if (this.$refs.ysForm3.validate) { this.ysStep = 4; }
      },
      ysStartLoading() {
        this.ysStopLoading();
        var i = 1;
        this.ysCurrentMessage = this.ysMessages[0];
        this.ysMessageInterval = setInterval(() => {
          this.ysCurrentMessage = this.ysMessages[i++ % this.ysMessages.length];
        }, 2000);
      },
      ysStopLoading() {
        if (this.ysMessageInterval) { clearInterval(this.ysMessageInterval); this.ysMessageInterval = null; }
      },
      ysEpostaGonder(kime, token) {
        var okMail = auth.URL_MAIL + 'isl=confirmmail&email=' + kime + '&&token=' + token + this.$t('approve-your-mail-from-url-address');
        let formData = new FormData();
        formData.append('Konu', this.$t('E-Posta-Onay-Maili'));
        formData.append('to', kime);
        formData.append('formattedMessage', okMail);
        formData.append('mailType', '0');
        axios.defaults.baseURL = auth.API_URL;
        axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
        axios.post(auth.API_URL + 'api/Helpers/SendEmail', formData, { headers: {} }).then(response => {
          this.text1 = response.data == true
            ? this.$t('Approval-mail-sent-registered-system-approving-your-mail')
            : this.$t('user-record-created-approval-been-sent-mail');
          this.snackbar = true;
        }).catch(() => {});
      },
      ysSaveUser() {
        if (this.YeniSirketKullanici.Sifre !== this.ysConfirm) {
          this.ysStep = 3; this.ysErrorAlert = true; this.ysErrorMsg = this.$t('Passwords-do-not-match');
          return;
        }
        this.ysErrorAlert = false;
        this.ysBekle = true;
        this.ysStartLoading();

        var acikAdres = this.ysFatAcikAdres || ' ';
        var vergiDairesi = this.YeniSirketKullanici.VergiDairesi || ' ';
        var vergiNo = this.YeniSirketKullanici.VergiNumarasi || ' ';
        var postaKod = this.ysFatPostaKod || ' ';

        var musteribilgi = {
          Ad: this.ysUnvan, Ulke: this.ysFatUlke, Sehir: this.ysFatSehir, Ilce: this.ysFatIlce,
          Adres: acikAdres + ' ' + vergiDairesi + ' ' + vergiNo + ' ' + postaKod,
          UlkeID: this.secilenUlke,
        };
        this.YeniSirketKullanici.MusteriBilgi = [musteribilgi];
        var emailAlici = this.YeniSirketKullanici.Email;
        var params1 = this.YeniSirketKullanici;

        this.$http.post(auth.API_URL + 'api/Register/Create', params1, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
          this.ysStopLoading(); this.ysBekle = false;
          if (response.body.Status == true) {
            this.ysEpostaGonder(emailAlici, response.body.UserToken);
            this.text1 = this.$t('Yeni-Sirket-Kaydiniz-Olusturuldu');
            this.snackbar = true;
            this.dialogyenisirket = false; this.sirkettipi = '0';
            this.ysResetForm();
          } else {
            this.text1 = this.$t(response.body.ResponseMessage); this.snackbar = true;
          }
        }, () => {
          this.ysStopLoading(); this.ysBekle = false;
          this.text1 = 'Service Unavailable-' + this.$t('New-User'); this.snackbar = true;
        });
      },
      urunleredon() {this.UrunKayit.OdemeTip='0'; this.urunekrani = true; this.odemeekrani = false; this.tursabgoster = true; },
      monthlyFiyat(item) {
        const idx = this.yearlyItems.findIndex(e => e.PaketID === item.PaketID);
        return idx !== -1 && this.monthlyItems[idx] ? this.monthlyItems[idx].Fiyat : 0;
      },
      switchToYearlyAndGoBack() { this.urunleredon(); this.aylikyillikpaketler = '1'; },
      switchToKontorPaket(pkg) {
        if (!pkg || !this.kontorUrun) return;
        this.kontorAdet = pkg.qty;
        this.Odeme(this.kontorUrun, pkg.qty, pkg.gift);
      },
      Odeme(val, adet, gift) {
        if (this.sirkettipi == '0' && this.AnaSirket != null && this.AnaSirket && typeof(this.sirkettipi) != 'object') {
          if (val.PaketTip == 2) {
            this.kontorAdet = adet;
            this.kontorHediyeAdet = gift || 0;
            this.UrunKayit.Tutar = val.Fiyat * adet; this.toplamtutar = this.UrunKayit.Tutar;
          } else {
            this.kontorHediyeAdet = 0;
            this.UrunKayit.Tutar = val.Fiyat; this.parabirimi = val.ParaBirimi; this.toplamtutar = this.UrunKayit.Tutar;
          }
          this.alinanUrun = val.PaketAdi; this.alinanAdet = adet;
          this.MusteriUrun.PaketBilgi.PaketID = val.PaketID;
          this.secilenPaket = val;
          this.bannerGizli = false;
          this.kontorBannerGizli = false;
          this.odemeekrani = true; this.urunekrani = false;
          this.havaleKodu = this.defaultKod(8);
        } else { this.text1 = this.$t('Please-select-a-company'); this.snackbar = true; }
      },
      defaultKod(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (var i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * characters.length));
          return result + (Math.floor(Math.random() * 90000) + 10000);
        }
      },
      FaturaBilgileriKontrol() {
        if (this.musteriidurun != null && this.musteriidurun != '') {
          this.$http.post(auth.API_URL + 'api/Awed/MusteriIDSearch', { ID: this.musteriidurun }, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
            if (response.statusText == 'OK') { this.kayitliFatAdres = response.body[0].Adres; }
            else { this.text1 = this.$t('Fatura-Bilgileriniz-Kontrol-Edilemedi'); this.snackbar = true; }
          });
          if (!this.kayitliFatAdres) { this.fatDialog = true; }
        }
      },
      closeModal() { this.fatDialog = false; },
      FaturaBilgileriGuncellev2() { this.fatDialog = true; },
      FaturaBilgileriGuncelle() {
        if (this.musteriidurun != null && this.musteriidurun != '') {
          var prms = {
            Ulke: this.fatUlke, Sehir: this.fatSehir, Ilce: this.fatIlce,
            Adres: this.fatAcikAdres + ' ' + this.fatUnvan + ' ' + this.fatVergiDairesi + ' ' + this.fatVergiNo + ' ' + this.fatPostaKod,
            MusteriID: this.musteriidurun,
          };
          this.$http.post(auth.API_URL + 'api/Awed/MusteriUpdateInvoiceAdress', prms, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
            if (response.statusText == 'OK') { this.text1 = this.$t('Your-Billing-Information-Has-Been-Updated'); this.snackbar = true; }
            else { this.text1 = response.body.ResponseDescription; this.snackbar = true; }
          }, () => { this.text1 = 'Service Unavailable-Invoice'; this.snackbar = true; });
        }
        this.fatDialog = false;
      },
      SatinAl() {
        if (this.sozlesmeOnay == true) {
          this.UrunKayit.Tarih = getDateNow();
          this.UrunKayit.OdemeOnay = false;
          this.UrunKayit.Aciklama = this.havaleKodu;
          var manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
          var index = manageload.AnaSirketInfo.findIndex(p => p.MusteriID == this.musteriidurun);
          this.UrunKayit.UlkeID = manageload.AnaSirketInfo[index].UlkeID;
          this.$http.post(auth.API_URL + 'api/Register/PackageCustomerPaymentSave', this.UrunKayit, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
            if (response.body.Status == true) {
              if (response.body.SaveID != null && response.body.SaveID != '') {
                this.MusteriUrun.MusteriID = this.musteriidurun;
                this.MusteriUrun.PaketBilgi.PaketTip = this.pakettipi;
                this.MusteriUrun.OdemeBilgi.ID = response.body.SaveID;
                this.MusteriUrun.OdemeBilgi.OdemeTip = this.UrunKayit.OdemeTip;
                this.MusteriUrun.OdemeBilgi.OdemeOnay = false;
                this.MusteriUrun.OdemeBilgi.UlkeID = this.UrunKayit.UlkeID;
                if (this.pakettipi == 2) {
                  const toplamKontor = this.kontorAdet + this.kontorHediyeAdet;
                  this.MusteriUrun.KontorAdet = toplamKontor; this.MusteriUrun.KalanKontorAdet = toplamKontor;
                  this.MusteriUrun.BaslangicTarih = getDateNow(); this.MusteriUrun.BitisTarihi = getDateNow();
                } else {
                  this.MusteriUrun.KontorAdet = 0; this.MusteriUrun.KalanKontorAdet = 0;
                  this.MusteriUrun.BaslangicTarih = null; this.MusteriUrun.BitisTarihi = null;
                }
                this.$http.post(auth.API_URL + 'api/Register/PackageCustomerSave', this.MusteriUrun, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(resp => {
                  this.text1 = this.$t(resp.body.ResponseMessage); this.snackbar = true;
                  if (resp.body.Status == true) { setTimeout(() => { window.open('#/anasirket', '_self'); }, 4000); }
                }, () => { this.text1 = 'Service Unavailable-PackageCustomerSave'; this.snackbar = true; });
              }
            } else { this.text1 = this.$t(response.body.ResponseMessage); this.snackbar = true; }
          }, () => { this.text1 = 'Service Unavailable-ProductCustomerSave'; this.snackbar = true; });
        } else { this.text1 = this.$t('You-need-approve-contract'); this.snackbar = true; }
      },
      BinKodSorgula() {
        this.$http.post(auth.API_URL + 'api/ParamPos/GetBinCode', this.PaymentForm, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
          this.binResult = response.body; this.seciliozelOran = [];
          this.ozelOranlar.forEach(element => {
            if (this.binResult.SanalPosId == element.SanalPosId) {
              this.cardimageLink = element.KrediKartiBankaGorsel;
              element.TaksitOranlar.forEach(element1 => {
                if (element1.Oran > -1) {
                  var Tutar = (this.toplamtutar * element1.Oran / 100) + this.toplamtutar;
                  this.seciliozelOran.push({
                    TaksitLabel: element1.Taksit == 1 ? "Tek Çekim" : element1.Taksit + "Taksit",
                    TaksitAdet: element1.Taksit, SanalPosId: element.SanalPosId,
                    TaksitTutar: Tutar / element1.Taksit, ToplamTutar: Tutar,
                  });
                }
              });
              this.secilentaksit = this.seciliozelOran[0];
            }
          });
        }, () => { this.text1 = 'Service Unavailable-BinCode'; this.snackbar = true; });
      },
      isTursabPaket(item) {
        const ad = ((item && item.PaketAdi) || '').replace(/[üÜ]/g, 'u').toLowerCase();
        return ad.includes('tursab');
      },
      tursaburungit() {
        this.giris = false; this.Urunler = true;
        this.$http.post(auth.API_URL + 'api/Register/PackageList', { PaketID: 148, PaketTip: 1, MusteriID: null, AktifKontrolYapma: false, UlkeID: 1 }, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
          this.urunlerlist = response.body; this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.PaketTip == 1 && element.PaketID == 148) {
              this.tursaburun = element; this.tursabgoster = false; this.Odeme(element, 0); return;
            }
          });
        }, () => { this.text1 = 'Service Unavailable-ProductList'; this.snackbar = true; });
      },
      sysLogin, getDateNow, guncelle, userlist,
    },

    filters: {
      parabirimi(p) {
        if (p == 'TRY') return ' ₺';
        else if (p == 'EUR') return ' €';
        else if (p == 'USD') return ' $';
      },
      dateformat(t) { return helpers.dateformat(t); },
      moneyformat(m) { return helpers.moneyformat(m); },
      bakiyekontrol(m) { return helpers.bakiyekontrol(m); },
      fmtInt(n) { return (n || 0).toLocaleString('tr-TR'); },
    },

    beforeMount: beforeMount,
    components: { 'navi': navi, altaciklama, genelsatissozlesme, StripeCheckout },

    watch: {
      'aylikyillikpaketler': function(value) {
        if (value == 1) {
          this.productshow = [];
          this.urunlerlist.forEach(e => { if (e.PaketTip == 1 && e.DonemAdet == 12 && e.PaketID != 148 && e.PaketID != 160) this.productshow.push(e); });
        } else {
          this.productshow = [];
          this.urunlerlist.forEach(e => { if (e.PaketTip == 1 && e.DonemAdet == 1 && e.PaketID != 148 && e.PaketID != 160) this.productshow.push(e); });
        }
      },
      'secilentaksit': function(value) { this.toplamtutar = value.ToplamTutar; },
      'pakettipi': function(value) {
        if (value == '1') {
          this.productshow = [];
          this.urunlerlist.forEach(e => {
            if (e.PaketTip == 1 && e.PaketID != 148) {
              if (this.aylikyillikpaketler == '0' && e.DonemAdet == 1) this.productshow.push(e);
              if (this.aylikyillikpaketler == '1' && e.DonemAdet == 12) this.productshow.push(e);
            }
          });
        } else {
          this.productshow = [];
          this.urunlerlist.forEach(e => {
            if (e.PaketTip == 2 && e.PaketID != 148) {
              this.productshow.push(e);
              this.toplamkontorFiyat = this.kontorAdet * e.Fiyat;
              this.tekkontorFiyat = e.Fiyat;
            }
          });
        }
      },
      'kontorAdet': function(value) {
        var a = parseInt(value);
        if (Number.isInteger(a)) { this.toplamkontorFiyat = value * this.tekkontorFiyat; }
        else { this.kontorAdet = 1; }
      },
      'UrunKayit.OdemeTip': function(value) {
        this.toplamtutar = this.UrunKayit.Tutar;
        if (value == '0') { this.havale = true; this.kredikarti = false; }
        else {
          this.havale = false; this.kredikarti = true;
          this.$http.post(auth.API_URL + 'api/BankPos/Get', { CompanyCode: 1, PosCode: 'OCT', arkmanPayment: 'true' }, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
            this.seciliozelOran = []; this.ozelOranlar = response.body.Taksitler;
            this.ozelOranlar.forEach(el => {
              var Tutar = (this.toplamtutar * el.VadeFarkYuzdeSatis / 100) + this.toplamtutar;
              this.seciliozelOran.push({ TaksitLabel: el.TaksitAciklama, TaksitAdet: el.TaksitAdet, TaksitTutar: Tutar / el.TaksitAdet, ToplamTutar: Tutar });
            });
            this.secilentaksit = this.seciliozelOran[0];
          }, () => { this.text1 = 'Service Unavailable-BankPos'; this.snackbar = true; });
        }
      },
      'AnaSirket': function(value) {
        this.loadingdialog = true;
        window.localStorage.setItem('active', '1');
        if (value != null) {
          this.AnaSirketler.forEach(element => {
            if (element.id == value) {
              this.musteriidurun = element.musteriid;
              this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', { MusteriID: this.musteriidurun }, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
                window.localStorage.setItem('active', response.body.UyelikBitisTarihi == null ? '0' : '1');
              });
              var manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
              var index = manageload.AnaSirketInfo.findIndex(p => p.MusteriID == element.musteriid);
              if (index != -1) {
                this.dot9Aktif = manageload.AnaSirketInfo[index].MusteriID == 1941;
                this.$http.post(auth.API_URL + 'api/Register/PackageList', { PaketID: null, PaketTip: 0, MusteriID: null, UlkeID: manageload.AnaSirketInfo[index].UlkeID, AktifKontrolYapma: null }, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
                  this.urunlerlist = response.body.filter(e => !this.isTursabPaket(e)); this.productshow = [];
                  if (this.aylikyillikpaketler == '1') {
                    this.urunlerlist.forEach(e => { if (e.PaketTip == 1 && e.DonemAdet == 12 && e.PaketID != 148) this.productshow.push(e); });
                  } else {
                    this.urunlerlist.forEach(e => { if (e.PaketTip == 1 && e.DonemAdet == 1 && e.PaketID != 148) this.productshow.push(e); });
                  }
                }, () => { this.text1 = 'Service Unavailable-ProductList'; this.snackbar = true; this.loadingdialog = false; });
              } else { this.text1 = this.$t('Fiyat-Listesi-Icin-Ulke-Kodu-Bulunamadi'); this.snackbar = true; }
            }
          });
        }
        this.loadingdialog = false;
      },
      'sirkettipi': function(value) {
        if (value == '0') { this.mevcutsirketmi = true; this.yenisirket = false; this.dialogyenisirket = false; }
        else {
          this.mevcutsirketmi = false; this.yenisirket = true;
          this.$http.post(auth.API_URL + 'api/Awed/WebCountryList', null, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
            this.ulkeitems = response.body.filter(item => item.ParaBirimi == 'TRY');
            if (this.ulkeitems.length > 0) { this.secilenUlke = this.ulkeitems[0].UlkeID; }
          }, () => { this.text1 = 'Service Unavailable-WebCountryList'; this.snackbar = true; });
        }
      },
    },
  };

  function beforeMount() {
    if (window.location.host == 'next.arkman.co.uk') { this.coukAktif = true; }
    this.AnaSirket = null;
    var sirketlers = [];
    var response1 = JSON.parse(window.localStorage.getItem('response'));
    Object.keys(response1.MusteriDbler).forEach(key => {
      sirketlers.push({
        text: response1.MusteriDbler[key].Ad, id: response1.MusteriDbler[key].MusteriKod,
        musteriid: response1.MusteriDbler[key].MusteriId, baglisirketler: response1.MusteriDbler[key].GenelSirketler,
      });
    });
    this.AnaSirketler = sirketlers;
    this.AnaSirket = this.$route.query.sirket || (sirketlers.length > 0 ? sirketlers[0].id : null);
    this.stripe = window.Stripe('pk_test_51Qi6HsBMw00zPru8pBIuLpW4lHnr2o0z1JHrFOrrJBA6uFmqvdhFnrC2V74rjvVQauAx893KhE8oHRJynyZaeUx200Ufsr2YcJ');
  }

  function guncelle() {
    var response1 = JSON.parse(window.localStorage.getItem('response'));
    this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', { Email: response1.Email }, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(response => {
      window.localStorage.setItem('WebUserManageLoad', JSON.stringify(response.body));
      this.pass = response.body.UserInfo.Sifre;
      var sirketlers = [];
      Object.keys(response1.MusteriDbler).forEach(key => {
        sirketlers.push({ text: response1.MusteriDbler[key].Ad, id: response1.MusteriDbler[key].MusteriKod, musteriid: response1.MusteriDbler[key].MusteriId, baglisirketler: response1.MusteriDbler[key].GenelSirketler });
      });
      this.AnaSirketler = sirketlers;
    }, () => { this.text1 = 'Service Unavailable-WebUserManageLoad'; this.snackbar = true; });
  }

  function getDateNow() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    return today.getFullYear() + '-' + mm + '-' + dd;
  }

  function userlist() {
    var response = JSON.parse(window.localStorage.getItem('response'));
    this.$http.post(auth.API_URL + 'api/Register/WebUserConnList', { Email: response.Email }, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(() => {}, () => { this.text1 = 'Service Unavailable-WebUserConnList'; this.snackbar = true; });
  }

  function sysLogin(userId, musteriId, anasirketid, sirketler) {
    if (sirketler.length > 0) {
      var response = JSON.parse(window.localStorage.getItem('response'));
      this.Sirket.id = sirketler[0].SirketKodu;
      this.Sirket.text = sirketler[0].SirketAdi;
      this.Sirket.unvan = sirketler[0].SirketUnvani;
      this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', { SirketKodu: this.Sirket.id }, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }).then(resp => {
        window.localStorage.setItem('credentials', JSON.stringify({
          AnaSirketKodu: anasirketid, MusteriID: musteriId, UserID: userId,
          SirketKodu: this.Sirket.id, SirketAdi: this.Sirket.text, SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler, EArsiv: resp.body.OpsiyonBilgileri.EArsiv,
          EFatura: resp.body.OpsiyonBilgileri.EFaturaKullaniyor, CoperSirketNo: 0,
        }));
        window.localStorage.removeItem('sirketler');
        auth.logingiris(this, { Email: response.Email, Password: this.pass, ActiveMusteriKod: anasirketid }, this.$route.query.redirect);
      }, () => { this.text1 = 'Service Unavailable-Company Get'; this.snackbar = true; });
    } else { this.text1 = this.$t('No-sub-company-for-parent-company'); this.snackbar = true; }
  }
</script>

<style scoped>
.maindiv-wrap {
  padding-top: 64px;
  width: 100%;
  margin-left: 0 !important;
}
.page *, .page *::before, .page *::after { box-sizing: border-box; }
.page { max-width: 1200px; margin: 0 auto; padding: 1.5rem 1rem;
  --navy: #1a3a6b; --navy-dark: #102a52;
  --green: #27ae60; --green-dark: #1e8449;
  --red: #c0392b; --red-dark: #96281b;
  --amber: #d97706; --card-border: #d0d8e8;
  --text-main: #1a1a2e; --text-sub: #4a5568; --text-muted: #718096;
  --bg-page: #f0f4f9; --bg-card: #ffffff;
}
.hdr { text-align: center; margin-bottom: 1rem; }
.hdr h1 { font-size: 26px; font-weight: 700; color: var(--navy); margin-bottom: 6px; }
.hdr p { color: var(--text-sub); font-size: 14px; }

/* Şirket seçimi kutusu */
.co-box { background: var(--bg-card); border-radius: 18px; overflow: hidden; margin-bottom: 1.5rem; box-shadow: 0 4px 24px rgba(26,58,107,.10); border: 1.5px solid var(--card-border); }
.co-head { background: linear-gradient(135deg, var(--navy) 0%, #1e4080 100%); padding: 16px 24px; display: flex; align-items: center; gap: 12px; }
.co-head-icon { width: 40px; height: 40px; background: rgba(255,255,255,.12); border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
.co-head-txt { flex: 1; }
.co-head-txt strong { display: block; font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 1px; }
.co-head-txt span { font-size: 12px; color: rgba(255,255,255,.65); }
.co-body { padding: 20px 24px; }

.co-radios { display: flex; gap: 10px; margin-bottom: 18px; }
.co-radio { flex: 1; position: relative; cursor: pointer; }
.co-radio input { position: absolute; opacity: 0; width: 0; height: 0; }
.co-radio-label { display: flex; align-items: center; gap: 10px; padding: 12px 16px; border: 2px solid var(--card-border); border-radius: 12px; transition: all .2s; background: #f7faff; }
.co-radio input:checked + .co-radio-label { border-color: var(--navy); background: #eef3ff; box-shadow: 0 2px 10px rgba(26,58,107,.12); }
.co-radio-dot { width: 18px; height: 18px; border: 2px solid #c0cce0; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center; transition: all .2s; }
.co-radio input:checked + .co-radio-label .co-radio-dot { border-color: var(--navy); }
.co-radio input:checked + .co-radio-label .co-radio-dot::after { content: ''; width: 8px; height: 8px; background: var(--navy); border-radius: 50%; display: block; }
.co-radio-txt strong { display: block; font-size: 13.5px; font-weight: 700; color: var(--text-main); }
.co-radio-txt span { font-size: 11px; color: var(--text-muted); }
.co-radio input:checked + .co-radio-label .co-radio-txt strong { color: var(--navy); }
.co-radio-ico { font-size: 20px; margin-right: 2px; }

.co-select-lbl { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--text-muted); margin-bottom: 7px; display: block; }
.co-select-wrap { position: relative; margin-top: 4px; }
.co-select { width: 100%; padding: 13px 44px 13px 16px; border: 2px solid var(--card-border); border-radius: 12px; font-size: 14px; font-weight: 600; color: var(--text-main); background: var(--bg-card); appearance: none; -webkit-appearance: none; cursor: pointer; outline: none; transition: border-color .2s, box-shadow .2s; font-family: inherit; }
.co-select:focus { border-color: var(--navy); box-shadow: 0 0 0 3px rgba(26,58,107,.12); }
.co-select-arrow { position: absolute; right: 14px; top: 50%; transform: translateY(-50%); font-size: 16px; color: var(--navy); pointer-events: none; }

.co-new-btn-wrap { margin-top: 0; }
.co-new-open-btn { width: 100%; display: flex; align-items: center; gap: 14px; padding: 16px 20px; background: linear-gradient(135deg,#f0f5ff 0%,#e8f0fe 100%); border: 2px dashed #93aed4; border-radius: 14px; cursor: pointer; transition: all .2s; text-align: left; }
.co-new-open-btn:hover { border-color: var(--navy); background: linear-gradient(135deg,#e8f0fe,#dde8ff); box-shadow: 0 4px 16px rgba(26,58,107,.12); transform: translateY(-1px); }
.co-new-btn-icon { width: 44px; height: 44px; background: var(--navy); color: #fff; border-radius: 11px; display: flex; align-items: center; justify-content: center; font-size: 22px; font-weight: 700; flex-shrink: 0; }
.co-new-btn-txt { flex: 1; }
.co-new-btn-txt strong { display: block; font-size: 14px; font-weight: 700; color: var(--navy); margin-bottom: 2px; }
.co-new-btn-txt span { font-size: 12px; color: var(--text-muted); }
.co-new-btn-arrow { font-size: 20px; color: var(--navy); opacity: .5; }

/* Yeni şirket modalı */
.co-overlay {
  display: none; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(10,20,40,.55); z-index: 1000; align-items: center; justify-content: center;
  --navy: #1a3a6b; --navy-dark: #102a52;
  --green: #27ae60; --green-dark: #1e8449;
  --red: #c0392b; --red-dark: #96281b;
  --amber: #d97706; --card-border: #d0d8e8;
  --text-main: #1a1a2e; --text-sub: #4a5568; --text-muted: #718096;
  --bg-page: #f0f4f9; --bg-card: #ffffff;
}
.co-overlay.open { display: flex; }
.co-modal { background: #fff; border-radius: 20px; width: min(560px,94vw); max-height: 88vh; overflow-y: auto; box-shadow: 0 24px 70px rgba(0,0,0,.22); }
.co-modal-head { background: linear-gradient(135deg, var(--navy) 0%, #1e4a8a 100%); padding: 22px 24px; display: flex; align-items: center; gap: 14px; border-radius: 20px 20px 0 0; }
.co-modal-head-icon { width: 44px; height: 44px; background: rgba(255,255,255,.15); border-radius: 11px; display: flex; align-items: center; justify-content: center; font-size: 22px; flex-shrink: 0; }
.co-modal-title { font-size: 17px; font-weight: 700; color: #fff; margin-bottom: 2px; }
.co-modal-sub { font-size: 12px; color: rgba(255,255,255,.68); }
.co-modal-close { background: rgba(255,255,255,.15); border: none; cursor: pointer; color: #fff; width: 30px; height: 30px; border-radius: 50%; font-size: 18px; display: flex; align-items: center; justify-content: center; margin-left: auto; flex-shrink: 0; transition: background .2s; }
.co-modal-close:hover { background: rgba(255,255,255,.28); }
.co-modal-body { padding: 24px 24px 8px; }
.co-modal-fields { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
.co-modal-field { display: flex; flex-direction: column; gap: 6px; }
.co-modal-field.full { grid-column: 1 / -1; }
.co-modal-field label { font-size: 11.5px; font-weight: 700; color: var(--text-muted); text-transform: uppercase; letter-spacing: .4px; }
.co-modal-field .req { color: var(--red); }
.co-modal-field input, .co-modal-field select { padding: 11px 14px; border: 1.5px solid var(--card-border); border-radius: 10px; font-size: 13.5px; color: var(--text-main); outline: none; transition: border-color .2s; font-family: inherit; background: var(--bg-card); width: 100%; }
.co-modal-field input:focus, .co-modal-field select:focus { border-color: var(--navy); box-shadow: 0 0 0 3px rgba(26,58,107,.1); }
.co-modal-foot { padding: 16px 24px 22px; display: flex; justify-content: flex-end; gap: 10px; border-top: 1px solid var(--card-border); margin-top: 16px; }
.co-modal-cancel { background: transparent; border: 1.5px solid var(--card-border); color: var(--text-muted); padding: 10px 22px; border-radius: 10px; font-size: 13px; font-weight: 600; cursor: pointer; transition: all .2s; }
.co-modal-cancel:hover:not(:disabled) { background: #f0f4f9; border-color: #b8c4d8; }
.co-modal-save { background: var(--navy); color: #fff; border: none; padding: 10px 26px; border-radius: 10px; font-size: 13.5px; font-weight: 700; cursor: pointer; transition: background .2s, transform .1s; box-shadow: 0 4px 14px rgba(26,58,107,.25); display: inline-flex; align-items: center; justify-content: center; gap: 6px; min-width: 100px; }
.co-modal-save:hover:not(:disabled) { background: var(--navy-dark); }
.co-modal-save:active:not(:disabled) { transform: scale(.98); }
.co-modal-save:disabled, .co-modal-cancel:disabled { opacity: .6; cursor: not-allowed; }

.co-overlay .co-modal.co-modal-stepper { width: min(900px, 96vw); }
.co-modal-stepper .co-modal-body { padding: 0; }
.co-modal-stepper .v-stepper { box-shadow: none; border-radius: 0 0 20px 20px; }
.ys-loading { display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 10px 0 16px; }
.ys-loading p { font-size: 13px; font-weight: 600; color: var(--green-dark); margin: 0; }

.tabs { display: flex; background: #fff; border: 1px solid var(--card-border); border-radius: 12px; padding: 5px; gap: 4px; width: fit-content; margin: 0 auto 1.5rem; }
.tab { padding: 10px 26px; border-radius: 9px; border: none; background: transparent; cursor: pointer; font-size: 14px; font-weight: 600; color: var(--text-sub); transition: all .2s; display: flex; align-items: center; gap: 6px; }
.tab.active { background: var(--navy); color: #fff; }
.tab:hover:not(.active) { background: #eef2fa; }

.bill-wrap { display: flex; justify-content: center; margin-bottom: 1.25rem; }
.bill-seg { display: inline-flex; background: #e2e8f4; border-radius: 14px; padding: 5px; box-shadow: 0 2px 8px rgba(26,58,107,.10); }
.bill-btn { position: relative; padding: 12px 28px; border: none; border-radius: 10px; cursor: pointer; font-size: 14px; font-weight: 700; color: var(--text-muted); background: transparent; transition: color .2s; display: flex; flex-direction: column; align-items: center; gap: 3px; white-space: nowrap; }
.bill-btn.active { background: #fff; color: var(--navy); box-shadow: 0 2px 10px rgba(26,58,107,.15); }
.bill-btn.active.yearly { background: var(--navy); color: #fff; }
.bill-sub { font-size: 10px; font-weight: 700; letter-spacing: .4px; opacity: .7; text-transform: uppercase; }
.bill-btn.active .bill-sub { opacity: 1; }
.bill-gift { display: inline-block; font-size: 10px; font-weight: 700; background: #f59e0b; color: #78350f; padding: 2px 8px; border-radius: 10px; margin-top: 2px; opacity: .55; transition: opacity .2s; }
.bill-btn.active.yearly .bill-gift { opacity: 1; }

.yr-banner { display: none; margin-bottom: 1.25rem; background: var(--navy); border-radius: 14px; overflow: hidden; }
.yr-banner.show { display: flex; align-items: stretch; }
.ban-stripe { width: 6px; background: #f59e0b; flex-shrink: 0; }
.ban-body { display: flex; align-items: center; gap: 14px; padding: 14px 20px; flex: 1; flex-wrap: wrap; }
.ban-icon { width: 42px; height: 42px; border-radius: 10px; background: rgba(245,158,11,.2); display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 22px; }
.ban-txt strong { font-size: 14px; color: #fff; display: block; margin-bottom: 2px; }
.ban-txt span { font-size: 12px; color: rgba(255,255,255,.75); line-height: 1.5; }
.ban-pill { background: #f59e0b; color: #78350f; font-size: 12px; font-weight: 600; padding: 5px 13px; border-radius: 20px; white-space: nowrap; flex-shrink: 0; margin-left: auto; }

.grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(170px, 1fr)); gap: 14px; align-items: stretch; }

.card { background: var(--bg-card); border: 1.5px solid var(--card-border); border-radius: 16px; overflow: hidden; display: flex; flex-direction: column; height: 100%; transition: border-color .2s; }
.card:hover { border-color: #7a9fc4; }
.card.featured { border: 2.5px solid var(--navy); }
.card.lisans { border: 2.5px solid var(--navy); background: linear-gradient(160deg, #0f2547 0%, #1a3a6b 100%); }
.card.lisans .badge-row { background: #0f2547; }

.badge-row { height: 26px; display: flex; align-items: center; justify-content: center; background: transparent; flex-shrink: 0; }
.card.featured .badge-row { background: var(--navy); }
.pop-lbl { display: none; align-items: center; gap: 5px; color: #fff; font-size: 10.5px; font-weight: 700; letter-spacing: .4px; }
.card.featured .pop-lbl, .card.lisans .pop-lbl { display: flex; }
.pop-star { width: 14px; height: 14px; background: #f59e0b; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; font-size: 8px; color: #78350f; flex-shrink: 0; }

.card-top { padding: 14px 16px 12px; text-align: center; }
.card-name { font-size: 15px; font-weight: 700; color: var(--navy); }
.divider { height: 1px; background: var(--card-border); margin: 0 16px; }
.feats { padding: 12px 16px; flex: 1; }
.feat { display: flex; align-items: center; gap: 7px; padding: 5px 0; font-size: 12.5px; color: var(--text-sub); border-bottom: .5px solid #eef2fa; }
.feat:last-child { border-bottom: none; }
.feat .fi { font-size: 15px; flex-shrink: 0; width: 18px; text-align: center; }

.price-box { text-align: center; padding: 10px 16px 6px; }
.price-was { font-size: 11.5px; color: var(--text-muted); text-decoration: line-through; margin-bottom: 1px; }
.price-amt { font-size: 22px; font-weight: 700; color: var(--red); }
.price-per { font-size: 11px; color: var(--text-muted); margin-top: 2px; }
.price-save { display: inline-flex; align-items: center; gap: 3px; margin-top: 5px; background: #fef3c7; color: #92400e; font-size: 11px; font-weight: 600; padding: 2px 9px; border-radius: 10px; border: 1px solid #fde68a; }

/* Paket detay modal */
.det-modal { background: #fff; border-radius: 20px; padding: 28px; }
.det-mhead { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.det-mtitle { font-size: 17px; font-weight: 700; color: #1a3a6b; }
.det-mclose { background: none; border: none; cursor: pointer; font-size: 26px; color: #718096; padding: 0 6px; line-height: 1; border-radius: 6px; }
.det-mclose:hover { background: #f0f4f9; }
.det-mtbl { width: 100%; border-collapse: collapse; }
.det-mtbl th { background: #f0f4f9; color: #718096; font-size: 12px; font-weight: 600; padding: 10px 14px; text-align: left; }
.det-mtbl th:last-child { text-align: right; }
.det-mtbl td { padding: 10px 14px; font-size: 13.5px; border-bottom: .5px solid #d0d8e8; color: #4a5568; }
.det-mtbl td:last-child { text-align: right; font-weight: 700; color: #1a1a2e; }
.det-mtbl tr:last-child td { border-bottom: none; }
.det-mfi { font-size: 16px; vertical-align: -3px; margin-right: 7px; }
.det-mnote { margin-top: 14px; font-size: 12px; color: #c0392b; line-height: 1.6; padding: 10px 13px; background: #fdf0ef; border-radius: 8px; border: 1px solid #f5c6c2; }

/* Upsell dialog */
.ups-modal { background: #fff; border-radius: 24px; overflow: hidden; }
.ups-hdr { background: #27ae60; padding: 32px 28px 26px; text-align: center; position: relative; }
.ups-hdr-navy { background: #1a3a6b; }
.ups-close-btn { position: absolute; top: 12px; right: 14px; background: rgba(255,255,255,.2); border: none; color: #fff; width: 32px; height: 32px; border-radius: 50%; cursor: pointer; font-size: 20px; line-height: 1; display: flex; align-items: center; justify-content: center; }
.ups-close-btn:hover { background: rgba(255,255,255,.35); }
.ups-hdr-ico { font-size: 38px; margin-bottom: 12px; }
.ups-hdr-title { font-size: 19px; font-weight: 700; color: #fff; margin-bottom: 10px; line-height: 1.35; }
.ups-hdr-sub { font-size: 13.5px; color: rgba(255,255,255,.88); line-height: 1.6; margin: 0; }
.ups-body { padding: 22px 22px 26px; display: flex; flex-direction: column; gap: 14px; }
.ups-compare { display: flex; align-items: center; gap: 10px; }
.ups-box { flex: 1; border-radius: 14px; padding: 16px 12px; text-align: center; }
.ups-cur-box { background: #f7faff; border: 1.5px solid #d0d8e8; }
.ups-rec-box { background: #f0fdf4; border: 2px solid #27ae60; }
.ups-box-lbl { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: #718096; margin-bottom: 8px; }
.ups-rec-lbl { color: #15803d !important; }
.ups-box-qty { font-size: 21px; font-weight: 700; color: #1a1a2e; line-height: 1.25; margin-bottom: 8px; }
.ups-rec-qty { color: #15803d; }
.ups-box-sub { font-size: 12px; font-weight: 500; color: #718096; }
.ups-box-sub-green { color: #15803d !important; }
.ups-gift-pill { display: inline-flex; align-items: center; background: #fef3c7; color: #92400e; font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 20px; border: 1px solid #fde68a; margin-bottom: 8px; }
.ups-box-price { font-size: 15px; font-weight: 600; color: #4a5568; }
.ups-cmp-arrow { font-size: 24px; color: #27ae60; flex-shrink: 0; font-weight: 700; }
.ups-diff-box { background: #fffbeb; border: 1.5px solid #fde68a; border-radius: 14px; padding: 14px 18px; text-align: center; }
.ups-diff-main { font-size: 19px; font-weight: 800; color: #92400e; margin-bottom: 5px; }
.ups-diff-sub { font-size: 13px; color: #78350f; line-height: 1.5; }
.ups-unit-box { background: #0f2240; border-radius: 14px; padding: 16px 20px; }
.ups-unit-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.ups-unit-lbl { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: rgba(255,255,255,.6); }
.ups-unit-pct { background: #f59e0b; color: #78350f; font-size: 13px; font-weight: 800; padding: 5px 14px; border-radius: 20px; }
.ups-unit-row { display: flex; align-items: center; gap: 16px; }
.ups-unit-cur { text-align: center; }
.ups-unit-cur-val { display: block; font-size: 18px; font-weight: 600; color: rgba(255,255,255,.4); text-decoration: line-through; }
.ups-unit-cur-lbl { display: block; font-size: 10px; color: rgba(255,255,255,.35); margin-top: 2px; }
.ups-unit-arr { color: #f59e0b; font-size: 20px; flex-shrink: 0; }
.ups-unit-new { text-align: center; }
.ups-unit-new-val { display: block; font-size: 32px; font-weight: 800; color: #4ade80; line-height: 1; }
.ups-unit-new-lbl { display: block; font-size: 10px; font-weight: 700; text-transform: uppercase; color: #4ade80; margin-top: 4px; letter-spacing: .5px; }
.ups-btn-yes { width: 100%; background: #27ae60; color: #fff; border: none; padding: 15px 18px; border-radius: 12px; font-size: 14px; font-weight: 700; cursor: pointer; transition: background .2s; }
.ups-btn-yes:hover { background: #1e8449; }
.ups-btn-no { width: 100%; background: #fff; color: #4a5568; border: 1.5px solid #d0d8e8; padding: 13px 18px; border-radius: 12px; font-size: 14px; font-weight: 600; cursor: pointer; transition: background .2s; margin-top: 2px; }
.ups-btn-no:hover { background: #f7faff; }

.actions { padding: 10px 12px 14px; display: flex; flex-direction: column; gap: 8px; }
.btn-det { width: 100%; background: transparent; border: 1.5px solid var(--navy); color: var(--navy); padding: 8px 10px; border-radius: 8px; font-size: 12px; font-weight: 600; cursor: pointer; transition: background .2s; display: flex; align-items: center; justify-content: center; gap: 5px; }
.btn-det:hover { background: #eef2fa; }
.btn-buy { width: 100%; background: var(--green); color: #fff; border: none; padding: 11px 10px; border-radius: 10px; font-size: 13px; font-weight: 700; cursor: pointer; transition: background .15s, transform .1s; display: flex; align-items: center; justify-content: center; gap: 6px; }
.btn-buy:hover { background: var(--green-dark); }
.btn-buy:active { transform: scale(.98); }
.card.featured .btn-buy { background: var(--navy); font-size: 14px; padding: 12px 10px; }
.card.featured .btn-buy:hover { background: var(--navy-dark); }

.lisans-icon { font-size: 28px; margin-bottom: 8px; display: block; }
.lisans-title { font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 2px; }
.lisans-sub { font-size: 11px; color: rgba(255,255,255,.6); }
.lisans-divider { height: 1px; background: rgba(255,255,255,.15); margin: 0 16px; }
.lisans-feats { padding: 12px 14px; flex: 1; }
.lisans-feat { display: flex; align-items: flex-start; gap: 8px; padding: 6px 0; border-bottom: .5px solid rgba(255,255,255,.1); font-size: 12px; color: rgba(255,255,255,.85); line-height: 1.4; }
.lisans-feat:last-child { border-bottom: none; }
.lisans-check { width: 16px; height: 16px; background: #f59e0b; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; font-size: 9px; color: #78350f; flex-shrink: 0; margin-top: 1px; }
.lisans-cta { padding: 10px 12px 14px; }
.btn-lisans { width: 100%; background: #f59e0b; color: #78350f; border: none; padding: 11px 10px; border-radius: 10px; font-size: 12.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px; transition: background .2s; }
.btn-lisans:hover { background: #fbbf24; }
.lisans-phone { text-align: center; margin-top: 7px; font-size: 12px; color: rgba(255,255,255,.5); }

/* Ek Kontör bölümü */
.k-layout { display: grid; grid-template-columns: 1fr 340px; gap: 20px; align-items: start; }
.k-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 12px; margin-bottom: 14px; }

.k-card { background: var(--bg-card); border: 1.5px solid var(--card-border); border-radius: 14px; overflow: hidden; display: flex; flex-direction: column; transition: border-color .2s; }
.k-card:hover { border-color: #7a9fc4; }
.k-card.k-feat { border: 2.5px solid var(--navy); }

.k-badge-row { height: 24px; display: flex; align-items: center; justify-content: center; background: transparent; flex-shrink: 0; }
.k-card.k-feat .k-badge-row { background: var(--navy); }
.k-pop { display: none; align-items: center; gap: 4px; color: #fff; font-size: 10px; font-weight: 700; letter-spacing: .3px; }
.k-card.k-feat .k-pop { display: flex; }
.k-star { width: 13px; height: 13px; background: #f59e0b; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; font-size: 7px; color: #78350f; }

.k-card-body { padding: 14px 14px 10px; text-align: center; flex: 1; }
.k-qty { font-size: 22px; font-weight: 700; color: var(--navy); line-height: 1.1; }
.k-qty span { font-size: 13px; font-weight: 600; color: var(--text-muted); }
.k-gift { display: inline-flex; align-items: center; gap: 4px; margin-top: 5px; background: #ecfdf5; color: #065f46; font-size: 11px; font-weight: 700; padding: 3px 9px; border-radius: 20px; border: 1px solid #6ee7b7; }
.k-gift-empty { height: 24px; margin-top: 5px; }
.k-price { font-size: 18px; font-weight: 700; color: var(--red); margin-top: 8px; }
.k-unit-wrap { margin-top: 8px; padding: 8px 10px; border-radius: 10px; background: #f0fdf4; border: 1.5px solid #86efac; text-align: center; }
.k-card.k-feat .k-unit-wrap { background: #eef2fa; border-color: #93aed4; }
.k-unit-label { font-size: 9.5px; font-weight: 700; color: #15803d; text-transform: uppercase; letter-spacing: .6px; margin-bottom: 3px; }
.k-card.k-feat .k-unit-label { color: var(--navy); }
.k-unit-price { font-size: 20px; font-weight: 700; color: #16a34a; line-height: 1.1; }
.k-card.k-feat .k-unit-price { color: var(--navy); }
.k-unit-old { font-size: 11px; color: var(--text-muted); text-decoration: line-through; margin-top: 1px; }
.k-unit-saving { display: inline-flex; align-items: center; gap: 3px; margin-top: 4px; background: #dcfce7; color: #15803d; font-size: 10.5px; font-weight: 700; padding: 3px 8px; border-radius: 8px; }
.k-card-actions { padding: 0 12px 12px; }
.k-btn { width: 100%; background: var(--green); color: #fff; border: none; padding: 9px; border-radius: 9px; font-size: 12.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 5px; transition: background .15s, transform .1s; }
.k-btn:hover { background: var(--green-dark); }
.k-btn:active { transform: scale(.98); }
.k-card.k-feat .k-btn { background: var(--navy); }
.k-card.k-feat .k-btn:hover { background: var(--navy-dark); }

.k-custom { background: var(--bg-card); border: 2px solid var(--navy); border-radius: 14px; overflow: hidden; }
.k-custom-head { background: linear-gradient(135deg, #1a3a6b 0%, #1e4a8a 100%); padding: 14px 18px; display: flex; align-items: center; gap: 12px; }
.k-custom-head-icon { width: 38px; height: 38px; background: rgba(245,158,11,.2); border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
.k-custom-head-txt strong { display: block; font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 2px; }
.k-custom-head-txt span { font-size: 11px; color: rgba(255,255,255,.65); }
.k-custom-body { padding: 16px; }
.k-custom-body p { font-size: 12px; color: var(--text-muted); margin-bottom: 12px; }
.k-custom-row { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
.k-custom-row input { width: 90px; padding: 8px 10px; border: 1.5px solid var(--card-border); border-radius: 8px; font-size: 16px; font-weight: 700; text-align: center; color: var(--text-main); outline: none; font-family: inherit; }
.k-custom-row input:focus { border-color: var(--navy); box-shadow: 0 0 0 3px rgba(26,58,107,.1); }
.k-custom-row span { font-size: 13px; color: var(--text-sub); }
.k-custom-res { font-size: 17px; font-weight: 700; color: var(--red); text-align: center; padding: 6px 0; }
.k-custom-btn { width: 100%; background: var(--green); color: #fff; border: none; padding: 10px; border-radius: 9px; font-size: 13px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px; transition: background .2s; margin-top: 8px; }
.k-custom-btn:hover { background: var(--green-dark); }

.burn-panel { background: var(--bg-card); border: 1.5px solid var(--card-border); border-radius: 14px; overflow: hidden; }
.burn-head { background: var(--navy); padding: 14px 16px; display: flex; align-items: center; gap: 8px; }
.burn-head h3 { font-size: 14px; font-weight: 700; color: #fff; }
.burn-desc { font-size: 12px; color: rgba(255,255,255,.72); margin-top: 2px; }
.burn-tbl { width: 100%; border-collapse: collapse; }
.burn-tbl tr { border-bottom: .5px solid var(--card-border); }
.burn-tbl tr:last-child { border-bottom: none; }
.burn-tbl td { padding: 9px 14px; font-size: 12.5px; color: var(--text-sub); }
.burn-tbl td:first-child { display: flex; align-items: center; gap: 7px; }
.burn-tbl td:last-child { text-align: right; font-weight: 600; color: var(--navy); white-space: nowrap; }
.burn-fi { font-size: 15px; width: 18px; text-align: center; flex-shrink: 0; }

@media (max-width: 860px) { .k-layout { grid-template-columns: 1fr; } }
@media (max-width: 640px) { .grid { grid-template-columns: repeat(2, 1fr); } .k-grid { grid-template-columns: repeat(2, 1fr); } .page { padding: 1rem .75rem; } .hdr h1 { font-size: 20px; } }
@media (max-width: 400px) { .grid { grid-template-columns: 1fr; } .k-grid { grid-template-columns: 1fr; } }

/* ========== ÖDEME EKRANI ========== */
.odeme-page { max-width: 1200px; margin: 0 auto; padding: 1rem;
  --navy: #1a3a6b; --green: #27ae60; --green-dark: #1e8449;
  --red: #c0392b; --card-border: #d0d8e8;
  --text-sub: #4a5568; --text-muted: #718096; --bg-soft: #f7faff;
}
.odeme-toolbar { display: flex; align-items: center; justify-content: space-between; background: #fff; border: 1px solid var(--card-border); border-radius: 12px; padding: 14px 20px; margin-bottom: 20px; flex-wrap: wrap; gap: 10px; }
.odeme-toolbar-title { font-size: 17px; font-weight: 700; color: var(--navy); }
.odeme-toolbar-sub { font-size: 15px; font-weight: 500; color: var(--text-sub); margin-left: 4px; }
.odeme-back-btn { background: transparent; border: 1.5px solid var(--red); color: var(--red); padding: 8px 16px; border-radius: 9px; font-size: 13px; font-weight: 600; cursor: pointer; transition: all .2s; }
.odeme-back-btn:hover { background: var(--red); color: #fff; }

/* Banner */
.sm-banner { border-radius: 18px; overflow: hidden; margin-bottom: 24px; box-shadow: 0 12px 48px rgba(245,158,11,.25); }
.sm-stripe { height: 6px; background: linear-gradient(90deg,#f59e0b,#fbbf24,#ef4444,#fbbf24,#f59e0b); background-size: 300%; animation: smShimmer 2s linear infinite; }
@keyframes smShimmer { 0%{background-position:0%} 100%{background-position:300%} }
.sm-inner { background: linear-gradient(135deg,#0a1628 0%,#0f2547 40%,#1a3a6b 100%); padding: 24px 28px; display: flex; align-items: center; gap: 24px; flex-wrap: wrap; }
.sm-left { display: flex; align-items: center; gap: 16px; flex: 1; min-width: 200px; }
.sm-icon { width: 52px; height: 52px; background: rgba(245,158,11,.15); border: 1.5px solid rgba(245,158,11,.35); border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 26px; flex-shrink: 0; }
.sm-body { flex: 1; }
.sm-body strong { display: block; font-size: 14px; font-weight: 800; color: #fff; margin-bottom: 4px; }
.sm-body span { font-size: 12px; color: rgba(255,255,255,.65); line-height: 1.55; }
.sm-pills { display: flex; gap: 6px; margin-top: 8px; flex-wrap: wrap; }
.sm-pill { display: inline-flex; align-items: center; gap: 3px; background: rgba(245,158,11,.12); border: 1px solid rgba(245,158,11,.3); color: #fde68a; font-size: 10.5px; font-weight: 700; padding: 3px 9px; border-radius: 20px; }
.sm-numbers { display: flex; gap: 16px; align-items: center; flex-shrink: 0; flex-wrap: wrap; }
.sm-num-card { text-align: center; border-radius: 16px; position: relative; overflow: hidden; }
.sm-num-card.sm-monthly { background: rgba(255,255,255,.04); border: 1px solid rgba(255,255,255,.1); padding: 14px 18px; }
.sm-num-card.sm-monthly .sm-num-lbl { font-size: 9.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: rgba(255,255,255,.4); margin-bottom: 6px; }
.sm-num-card.sm-monthly .sm-num-val { font-size: 18px; font-weight: 700; color: rgba(255,255,255,.38); text-decoration: line-through; line-height: 1; }
.sm-num-card.sm-monthly .sm-num-sub { font-size: 10px; color: rgba(255,255,255,.28); margin-top: 4px; }
.sm-infl { font-size: 10px; color: rgba(255,120,120,.85); font-weight: 700; margin-top: 5px; line-height: 1.4; text-align: center; }
.sm-infl-badge { display: inline-block; background: rgba(239,68,68,.15); border: 1px solid rgba(239,68,68,.35); color: #fca5a5; font-size: 9.5px; font-weight: 800; padding: 2px 8px; border-radius: 8px; margin-top: 4px; letter-spacing: .3px; }
.sm-arrow { font-size: 22px; color: rgba(255,255,255,.25); }
.sm-num-card.sm-save { background: linear-gradient(145deg,#1a0f00 0%,#2d1800 50%,#1a0f00 100%); border: 2px solid rgba(251,191,36,.6); box-shadow: 0 0 32px rgba(251,191,36,.25),inset 0 1px 0 rgba(255,255,255,.08); }
.sm-save-stripe { height: 4px; background: linear-gradient(90deg,#92400e,#fbbf24,#f59e0b,#fbbf24,#92400e); background-size: 250%; animation: saveStripe 2s linear infinite; }
@keyframes saveStripe { 0%{background-position:0%} 100%{background-position:250%} }
.sm-save-inner { padding: 16px 20px; }
.sm-num-card.sm-save .sm-num-lbl { font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: .7px; color: #fbbf24; margin-bottom: 8px; }
.sm-num-card.sm-save .sm-num-val { font-size: 30px; font-weight: 900; color: #fbbf24; line-height: 1; text-shadow: 0 0 20px rgba(251,191,36,.9),0 0 44px rgba(251,191,36,.6); animation: smGlow 1.8s ease-in-out infinite alternate; }
@keyframes smGlow { 0%{text-shadow:0 0 16px rgba(251,191,36,.7),0 0 36px rgba(251,191,36,.4)} 100%{text-shadow:0 0 28px rgba(251,191,36,1),0 0 56px rgba(251,191,36,.7),0 0 100px rgba(251,191,36,.35)} }
.sm-num-card.sm-save .sm-num-sub { font-size: 10.5px; color: rgba(251,191,36,.75); margin-top: 6px; font-weight: 600; }
.sm-num-avg { text-align: center; border-radius: 16px; overflow: hidden; border: 1.5px solid rgba(34,197,94,.45); }
.sm-avg-stripe { height: 4px; background: linear-gradient(90deg,#14532d,#4ade80,#22c55e,#4ade80,#14532d); background-size: 250%; animation: avgStripe 2.2s linear infinite; }
@keyframes avgStripe { 0%{background-position:0%} 100%{background-position:250%} }
.sm-avg-inner { padding: 12px 16px; background: linear-gradient(145deg,#052e16 0%,#0f3d1f 50%,#052e16 100%); }
.sm-num-avg-lbl { font-size: 9.5px; font-weight: 800; text-transform: uppercase; letter-spacing: .6px; color: #86efac; margin-bottom: 6px; }
.sm-num-avg-old { font-size: 14px; font-weight: 700; color: rgba(255,255,255,.32); text-decoration: line-through; margin-bottom: 4px; }
.sm-num-avg-val { font-size: 22px; font-weight: 800; color: #4ade80; line-height: 1; animation: avgGlow 2s ease-in-out infinite alternate; }
@keyframes avgGlow { 0%{text-shadow:0 0 12px rgba(74,222,128,.6)} 100%{text-shadow:0 0 22px rgba(74,222,128,.9),0 0 48px rgba(74,222,128,.5)} }
.sm-num-avg-sub { font-size: 10px; color: #86efac; margin-top: 5px; font-weight: 600; }
.sm-action-wrap { display: flex; flex-direction: column; align-items: center; gap: 8px; flex-shrink: 0; }
.sm-action { background: linear-gradient(135deg,#f59e0b 0%,#d97706 100%); color: #78350f; border: none; padding: 14px 22px; border-radius: 12px; font-size: 13px; font-weight: 800; cursor: pointer; transition: all .2s; box-shadow: 0 4px 20px rgba(245,158,11,.5); display: flex; flex-direction: column; align-items: center; gap: 3px; }
.sm-action:hover { transform: translateY(-2px); box-shadow: 0 8px 32px rgba(245,158,11,.7); }
.sm-action small { font-size: 10px; font-weight: 700; opacity: .8; }
.sm-no { font-size: 10.5px; color: rgba(255,255,255,.35); cursor: pointer; text-decoration: underline; text-underline-offset: 2px; }

/* Kontör yükseltme banneri */
.kontor-stripe { background: linear-gradient(90deg,#2563eb,#06b6d4,#3b82f6,#06b6d4,#2563eb) !important; }
.sm-num-card.sm-kontor-cur { background: rgba(255,255,255,.04); border: 1px solid rgba(255,255,255,.12); border-radius: 16px; padding: 14px 18px; text-align: center; min-width: 110px; }
.sm-num-card.sm-kontor-cur .sm-num-lbl { font-size: 9.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: rgba(255,255,255,.4); margin-bottom: 6px; }
.sm-num-val-cur { font-size: 22px; font-weight: 700; color: rgba(255,255,255,.7); line-height: 1; margin: 6px 0 4px; }
.sm-num-unit { font-size: 13px; font-weight: 600; }
.sm-num-sub-cur { font-size: 12px; color: rgba(255,255,255,.4); }
.sm-infl-blue { color: #93c5fd !important; border-color: rgba(147,197,253,.35) !important; background: rgba(59,130,246,.15) !important; }
.sm-num-val-kontor { font-size: 26px !important; }
.kontor-avg { border: 2px solid rgba(74,222,128,.75) !important; box-shadow: 0 0 32px rgba(74,222,128,.25); }
.kontor-avg .sm-avg-inner { padding: 16px 20px; }
.kontor-avg-old { font-size: 16px; font-weight: 700; color: rgba(255,255,255,.45); text-decoration: line-through; margin-bottom: 4px; }
.kontor-avg-val { font-size: 32px !important; }
.kontor-pct-badge { display: inline-block; margin-top: 10px; background: linear-gradient(135deg,#14532d,#4ade80 55%,#15803d); color: #052e16; font-size: 14px; font-weight: 900; padding: 7px 16px; border-radius: 22px; letter-spacing: .4px; box-shadow: 0 4px 16px rgba(74,222,128,.55); animation: pctPulse 2s ease-in-out infinite alternate; }
@keyframes pctPulse { 0%{box-shadow:0 4px 16px rgba(74,222,128,.5)} 100%{box-shadow:0 4px 28px rgba(74,222,128,.9),0 0 44px rgba(74,222,128,.35)} }

/* İki kolon düzeni */
.odeme-content { display: grid; grid-template-columns: 1fr 360px; gap: 24px; align-items: start; }
.odeme-right { position: sticky; top: 76px; }
.odeme-left { display: flex; flex-direction: column; gap: 20px; }

/* Paket özeti */
.pkg-summary { background: #fff; border: 1.5px solid var(--card-border); border-radius: 16px; overflow: hidden; }
.pkg-summary-head { background: linear-gradient(135deg,#1a3a6b 0%,#1e4080 100%); padding: 16px 20px; display: flex; align-items: center; justify-content: space-between; }
.pkg-summary-head h3 { font-size: 15px; font-weight: 700; color: #fff; }
.pkg-summary-badge { background: #f59e0b; color: #78350f; font-size: 10px; font-weight: 700; padding: 3px 10px; border-radius: 20px; }
.pkg-summary-body { padding: 16px 20px; }
.pkg-row { display: flex; justify-content: space-between; align-items: center; padding: 7px 0; font-size: 13px; border-bottom: .5px solid #eef2fa; }
.pkg-row:last-child { border-bottom: none; }
.pk { color: var(--text-muted); }
.pv { font-weight: 600; color: #1a1a2e; }
.pv-green { color: var(--green-dark); }

/* Ödeme kartı */
.pay-card { background: #fff; border: 1.5px solid var(--card-border); border-radius: 16px; overflow: hidden; }
.pay-card-head { padding: 16px 20px; border-bottom: 1px solid var(--card-border); display: flex; align-items: center; gap: 8px; }
.pay-card-head h3 { font-size: 15px; font-weight: 700; color: var(--navy); }
.pay-methods { display: flex; gap: 10px; padding: 16px 20px; border-bottom: 1px solid var(--card-border); }
.pay-method { flex: 1; border: 1.5px solid var(--card-border); border-radius: 11px; padding: 12px 14px; cursor: pointer; transition: all .2s; display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600; color: var(--text-sub); }
.pay-method:hover { border-color: #93aed4; }
.pay-method.selected { border-color: var(--navy); background: #f0f5ff; color: var(--navy); }
.pm-ico { font-size: 20px; }
.pm-radio { width: 16px; height: 16px; border: 2px solid var(--card-border); border-radius: 50%; margin-left: auto; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.pay-method.selected .pm-radio { border-color: var(--navy); }
.pm-dot { width: 8px; height: 8px; background: var(--navy); border-radius: 50%; display: block; }

/* Havale */
.havale-panel { padding: 20px; }
.havale-ref { background: linear-gradient(135deg,#fffbeb,#fef9ec); border: 1.5px solid #fde68a; border-radius: 12px; padding: 14px 18px; margin-bottom: 16px; }
.havale-ref p { font-size: 12.5px; color: #78350f; line-height: 1.6; margin-bottom: 10px; }
.ref-code-row { display: flex; align-items: center; gap: 10px; }
.ref-code { font-size: 22px; font-weight: 800; color: var(--red); letter-spacing: 2px; background: #fff; border: 1.5px solid #fca5a5; padding: 8px 16px; border-radius: 8px; }
.bank-info { background: var(--bg-soft); border: 1px solid var(--card-border); border-radius: 12px; padding: 14px 16px; }
.bank-info-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--text-muted); margin-bottom: 10px; }
.bank-field { display: flex; justify-content: space-between; align-items: center; padding: 6px 0; font-size: 12.5px; border-bottom: .5px solid #e2e8f0; flex-wrap: wrap; gap: 4px; }
.bank-field:last-child { border-bottom: none; }
.bk { color: var(--text-muted); font-size: 11.5px; }
.bv { font-weight: 700; color: #1a1a2e; font-family: monospace; letter-spacing: .3px; }

/* Kredi kartı */
.cc-panel { padding: 20px; }
.cc-note { background: #f0fdf4; border: 1px solid #86efac; border-radius: 10px; padding: 12px 16px; font-size: 12.5px; color: #15803d; display: flex; align-items: flex-start; gap: 8px; margin-bottom: 12px; line-height: 1.55; }
.taksit-wrap { margin-bottom: 12px; }
.taksit-head { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; color: var(--text-muted); margin-bottom: 10px; }
.taksit-row { display: flex; align-items: center; gap: 8px; padding: 6px 0; border-bottom: .5px solid #eef2fa; font-size: 12.5px; flex-wrap: wrap; }
.taksit-row:last-child { border-bottom: none; }
.taksit-tutar { color: var(--navy); font-weight: 600; margin-left: auto; }
.taksit-toplam { color: var(--text-muted); font-size: 11px; }

/* Sipariş kartı */
.order-card { background: #fff; border: 1.5px solid var(--card-border); border-radius: 16px; overflow: hidden; }
.order-card-head { background: var(--navy); padding: 16px 20px; }
.order-card-head h3 { font-size: 14px; font-weight: 700; color: #fff; }
.order-body { padding: 18px 20px; }
.order-line { display: flex; justify-content: space-between; align-items: flex-start; padding: 8px 0; font-size: 13px; border-bottom: .5px solid #eef2fa; }
.ol { color: var(--text-sub); }
.ov { font-weight: 600; color: #1a1a2e; text-align: right; }

/* Yıllık kazanç kutusu */
.yearly-win-box { border-radius: 16px; overflow: hidden; margin: 12px 0; box-shadow: 0 8px 32px rgba(34,197,94,.22); }
.ywb-stripe { height: 5px; background: linear-gradient(90deg,#22c55e,#f59e0b,#22c55e); background-size: 200%; animation: ywbShimmer 2.5s linear infinite; }
@keyframes ywbShimmer { 0%{background-position:0%} 100%{background-position:200%} }
.ywb-inner { background: linear-gradient(135deg,#052e16 0%,#14532d 55%,#166534 100%); padding: 18px 20px; }
.ywb-head { text-align: center; margin-bottom: 14px; padding-bottom: 12px; border-bottom: 1px solid rgba(34,197,94,.25); }
.ywb-head-ico { font-size: 26px; margin-bottom: 4px; }
.ywb-head-txt { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: .7px; color: #86efac; }
.ywb-row { display: flex; justify-content: space-between; font-size: 12.5px; padding: 6px 0; border-bottom: .5px solid rgba(34,197,94,.15); }
.ywb-row:last-of-type { border-bottom: none; }
.yw-lbl { color: rgba(255,255,255,.65); }
.yw-val { font-weight: 700; color: #86efac; }
.yw-muted { text-decoration: line-through; color: rgba(255,255,255,.35); font-weight: 400; }
.ywb-divider { height: 1px; background: rgba(34,197,94,.25); margin: 10px 0; }
.ywb-big { background: rgba(251,191,36,.12); border: 1.5px solid rgba(251,191,36,.4); border-radius: 12px; padding: 14px; text-align: center; margin-top: 10px; }
.ywb-big-lbl { font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: .6px; color: rgba(255,255,255,.55); margin-bottom: 6px; }
.ywb-big-val { font-size: 28px; font-weight: 800; color: #fbbf24; line-height: 1; text-shadow: 0 2px 14px rgba(251,191,36,.4); }
.ywb-big-sub { font-size: 12px; color: rgba(255,255,255,.6); margin-top: 6px; line-height: 1.5; }
.ywb-pills { display: flex; gap: 6px; flex-wrap: wrap; justify-content: center; margin-top: 10px; }
.ywb-pill { display: inline-flex; align-items: center; gap: 3px; background: rgba(34,197,94,.15); border: 1px solid rgba(34,197,94,.35); color: #86efac; font-size: 10.5px; font-weight: 700; padding: 3px 9px; border-radius: 20px; }

/* Toplam kutusu */
.order-total-box { border-radius: 14px; padding: 16px; margin: 12px 0; text-align: center; }
.order-total-monthly { background: linear-gradient(135deg,#f0f5ff,#e8f0fe); border: 1.5px solid #c3d5ee; }
.order-total-yearly { background: linear-gradient(135deg,#052e16,#14532d 50%,#166534 100%); border: 2.5px solid #22c55e; box-shadow: 0 8px 32px rgba(34,197,94,.35); }
.order-total-lbl { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--text-muted); margin-bottom: 4px; }
.order-total-yearly .order-total-lbl { color: #86efac; }
.order-total-amt { font-size: 30px; font-weight: 800; line-height: 1; color: var(--red); }
.order-total-yearly .order-total-amt { color: #fff; text-shadow: 0 2px 18px rgba(34,197,94,.5); font-size: 36px; }
.order-total-sub { font-size: 11px; color: var(--text-muted); margin-top: 4px; }
.order-total-yearly .order-total-sub { color: #86efac; font-weight: 700; }

/* Sözleşme + buton */
.contract-check { display: flex; align-items: flex-start; gap: 10px; padding: 12px 0; border-top: 1px solid var(--card-border); margin-top: 6px; }
.contract-check input[type=checkbox] { width: 17px; height: 17px; margin-top: 2px; accent-color: var(--navy); cursor: pointer; flex-shrink: 0; }
.contract-check label { font-size: 12px; color: var(--text-sub); line-height: 1.55; cursor: pointer; }
.contract-link { color: var(--navy); text-decoration: none; font-weight: 600; }
.contract-link:hover { text-decoration: underline; }
.btn-confirm { width: 100%; background: var(--green); color: #fff; border: none; padding: 14px 18px; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: background .15s,transform .1s; margin-top: 14px; }
.btn-confirm:hover:not(:disabled) { background: var(--green-dark); }
.btn-confirm:active:not(:disabled) { transform: scale(.98); }
.btn-confirm:disabled { background: #d0d8e8; cursor: not-allowed; }
.security-row { display: flex; align-items: center; justify-content: center; gap: 12px; padding-top: 12px; border-top: 1px solid var(--card-border); margin-top: 10px; flex-wrap: wrap; }
.sec-item { display: flex; align-items: center; gap: 4px; font-size: 11px; color: var(--text-muted); }

@media(max-width:900px) { .odeme-content { grid-template-columns: 1fr; } .sm-numbers { display: none; } }
@media(max-width:600px) { .sm-inner { padding: 16px; } .pay-methods { flex-direction: column; } }
</style>
